<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-12 text-start">
        <div class="div_header">
          <div class="div_header_link">
            <a :href="`/logins`">
              <div class="caret-left-back">
                <i class="bi bi-caret-left-fill"></i>
              </div>
            </a>
            <div>
              แบบประเมินความเข้าข่ายการแจ้งการมีบุคลากรด้านสิ่งแวดล้อมประจำโรงงานเบื้องต้น
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div id="stepperset" class="bs-stepper linear card-body py-0">
        <div class="bs-stepper-header" role="tablist">
          <div class="step" data-target="#step-1-part" :class="{ active: page == 1 }">
            <button type="button" class="step-trigger" role="tab" aria-controls="step-1-part" id="step-1-part-trigger">
              <span class="bs-stepper-circle">1</span>
              <span class="bs-stepper-label">กรอกข้อมูล<br />ผู้ต้องการประเมิน</span>
            </button>
          </div>
          <div class="line"></div>
          <div class="step" data-target="#step-2-part" :class="{ active: page == 2 }">
            <button type="button" class="step-trigger" role="tab" aria-controls="step-2-part" id="step-2-part-trigger">
              <span class="bs-stepper-circle">2</span>
              <span class="bs-stepper-label">รายการแบบประเมิน</span>
            </button>
          </div>
          <div class="line"></div>
          <div class="step" data-target="#step-3-part" :class="{ active: page == 3 }">
            <button type="button" class="step-trigger" role="tab" aria-controls="step-3-part" id="step-3-part-trigger">
              <span class="bs-stepper-circle">3</span>
              <span class="bs-stepper-label">ตรวจทานข้อมูล<br />ประกอบการประเมิน</span>
            </button>
          </div>
          <div class="line"></div>
          <div class="step" data-target="#step-4-part" :class="{ active: page == 4 }">
            <button type="button" class="step-trigger" role="tab" aria-controls="step-4-part" id="step-4-part-trigger">
              <span class="bs-stepper-circle">4</span>
              <span class="bs-stepper-label">ตรวจทานข้อมูล<br />ผู้ต้องการประเมิน</span>
            </button>
          </div>
          <div class="line"></div>
          <div class="step" data-target="#step-5-part" :class="{ active: page == 5 }">
            <button type="button" class="step-trigger" role="tab" aria-controls="step-5-part" id="step-5-part-trigger">
              <span class="bs-stepper-circle">5</span>
              <span class="bs-stepper-label">ยืนยันผล</span>
            </button>
          </div>
        </div>
      </div>

      <div class="card-body">
        <form class="needs-validation" novalidate autocomplete="off">
          <fieldset>
            <div class="card border-primary mb-3 border-evaluate" v-if="page == 1">
              <div class="card-header border-bottom-evaluate">
                <h4 class="text-primary mb-0 text-evaluate font-1_25">
                  กรอกข้อมูลผู้ต้องการประเมิน
                </h4>
              </div>
              <div class="card-body card-body-page-1">
                <button type="button" class="check-validator-1 d-none"
                  v-on:click="checkValidator('card-body-page-1', 'check_onchange')">Button for card-body-page-1 check
                  validator</button>
                <div class="row form-group mb-3">
                  <label
                    class="col-sm-2 col-form-label text-sm-end text-start default-text required-label">ขื่อผู้รับใบอนุญาตฯ</label>
                  <div class="col-sm-4">
                    <input type="text" class="form-control" name="factory_name" v-model="evaluate.factory_name"
                      onclick="check_validator_page1()" required />
                    <small class="text-danger" v-if="errors[`evaluate.factory_name`]">
                      {{ errors[`evaluate.factory_name`][0] }}
                    </small>
                  </div>
                  <label
                    class="col-sm-2 col-form-label text-sm-end text-start default-text required-label">เลขทะเบียนโรงงาน
                    (ใหม่)</label>
                  <div class="col-sm-4">
                    <input type="text" class="form-control" name="idcard" v-model="evaluate.fid"
                      onclick="check_validator_page1()" required pattern="^[0-9]{14}$"
                      title="เลขทะเบียนโรงงาน (ใหม่) จะต้องมี 14 หลัก โดยเป็น ตัวเลขเท่านั้น" data-v-max-length="14" />
                    <small class="text-danger" v-if="errors[`evaluate.fid`]">
                      {{ errors[`evaluate.fid`][0] }}
                    </small>
                  </div>
                </div>
                <div class="row form-group mb-3">
                  <label
                    class="col-sm-2 col-form-label text-sm-end text-start default-text required-label">เลขทะเบียนโรงงาน
                    (เก่า)</label>
                  <div class="col-sm-4">
                    <input type="text" class="form-control" name="dispfacreg" v-model="evaluate.dispfacreg"
                      onclick="check_validator_page1()" required />
                    <small class="text-danger" v-if="errors[`evaluate.dispfacreg`]">
                      {{ errors[`evaluate.dispfacreg`][0] }}
                    </small>
                  </div>
                  <label
                    class="col-sm-2 col-form-label text-sm-end text-start default-text required-label">เลขประจำตัวผู้เสียภาษี
                    13 หลัก
                  </label>
                  <div class="col-sm-4">
                    <input type="text" class="form-control" name="tax_id" v-model="evaluate.tax_id"
                      onclick="check_validator_page1()" required pattern="^[0-9]{13}$"
                      title="เลขประจำตัวผู้เสียภาษี จะต้องมี 13 หลัก โดยเป็น ตัวเลขเท่านั้น" data-v-max-length="13" />
                    <small class="text-danger" v-if="errors[`evaluate.tax_id`]">
                      {{ errors[`evaluate.tax_id`][0] }}
                    </small>
                  </div>
                </div>
                <div class="row form-group mb-3">
                  <label class="col-sm-2 col-form-label text-sm-end text-start default-text required-label">ชื่อ-นามสกุล
                    (ผู้ประสานงาน)</label>
                  <div class="col-sm-4">
                    <input type="text" class="form-control" name="contact_name" v-model="evaluate.contact_name"
                      onclick="check_validator_page1()" required />
                    <small class="text-danger" v-if="errors[`evaluate.contact_name`]">
                      {{ errors[`evaluate.contact_name`][0] }}
                    </small>
                  </div>
                  <label
                    class="col-sm-2 col-form-label text-sm-end text-start default-text required-label">e-mail</label>
                  <div class="col-sm-4">
                    <input type="email" class="form-control" name="email" v-model="evaluate.email"
                      onclick="check_validator_page1()" required />
                    <small class="text-danger" v-if="errors[`evaluate.email`]">
                      {{ errors[`evaluate.email`][0] }}
                    </small>
                  </div>
                </div>
                <div class="row form-group mb-3">
                  <label
                    class="col-sm-2 col-form-label text-sm-end text-start default-text required-label">เบอร์โทรศัพท์ผู้ประสานงาน</label>
                  <div class="col-sm-4">
                    <input type="text" class="form-control" name="telephone" v-model="evaluate.telephone"
                      onclick="check_validator_page1()" required pattern="\d{2,3}-?\d{3,4}-?\d{4}"
                      title="กรุณากรอกเบอร์โทร ที่ขึ้นต้นด้วย 0 และมีขีดกลางได้" />
                    <small class="text-danger" v-if="errors[`evaluate.telephone`]">
                      {{ errors[`evaluate.telephone`][0] }}
                    </small>
                  </div>
                </div>

                <div class="border border-danger py-2 px-4 rounded mt-4">
                  <div class="row">
                    <div class="col text-center">
                      <b>เงื่อนไขและข้อตกลง</b>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-auto text-left">
                      <b><u>รายละเอียด</u></b>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-auto text-left">1.</div>
                    <div class="col text-left">
                      <div>
                        แบบประเมินความเข้าข่ายการแจ้งการมีบุคลากรด้านสิ่งแวดล้อมประจำโรงงานนี้
                        เป็นเพียงแบบประเมินเบื้องต้น
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-auto text-left">2.</div>
                    <div class="col text-left">
                      <div>
                        ข้อมูลที่ท่านกรอก ต้องเป็นข้อมูลที่เป็นจริงทุกประการ
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-auto text-left">3.</div>
                    <div class="col text-left">
                      <div>
                        หากผลการประเมินระบุว่า
                        ท่านเข้าข่ายต้องแจ้งการมีบุคลากรด้านสิ่งแวดล้อมประจำโรงงาน
                        ท่านจะต้อง แนบหลักฐานที่แสดงว่า ท่านเข้าข่ายฯ
                        เพื่อประกอบการพิจารณาของเจ้าหน้าที่อีกครั้ง
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-auto text-left">4.</div>
                    <div class="col text-left">
                      <div>
                        ข้อมูลที่ท่านกรอก จะไม่ถูกนำไปเผยแพร่หรือใช้ในทางอื่น
                        นอกจากใช้ในกรมโรงงานอุตสาหกรรมเท่านั้น
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-center mt-2 form-check">
                  <div class="icheck-material-teal">
                    <input type="checkbox" class="form-check-input" id="checkbox-1" data-id="1" true-value="ยอมรับ"
                      false-value="ไม่ยอมรับ" v-model="evaluate.policy" required />
                    <label class="form-check-label" for="checkbox-1">ยอมรับเงื่อนไขและข้อตกลง</label>
                  </div>
                </div>
                <div class="d-flex justify-content-end mt-3">
                  <!-- <button type="button" id="step-1-next" class="btn btn-primary" @click="next()"
                                    :disabled="evaluate.policy == 'ไม่ยอมรับ'">ยืนยันและไปยังขั้นตอนต่อไป <i
                                        class="bi bi-arrow-right-square-fill"></i></button> -->
                  <button type="button" id="step-1-next" class="btn btn-primary"
                    @click="checkValidator('card-body-page-1', 'check_onsubmit_step_1_next')" :disabled="policyCheck">
                    ยืนยันและไปยังขั้นตอนต่อไป
                    <i class="bi bi-arrow-right-square-fill"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="card border-primary mb-3 border-evaluate" v-if="page == 2">
              <div class="card-header border-bottom-evaluate">
                <h4 class="text-primary mb-0 text-evaluate font-1_25">
                  รายการแบบประเมิน
                </h4>
              </div>
              <div class="card-body card-body-page-2">
                <button type="button" class="check-validator-2 d-none"
                  v-on:click="checkValidator('card-body-page-2', 'check_onchange')">Button for card-body-page-2 check
                  validator</button>
                <div class="card card-category">
                  <div class="card-header card-header-category">
                    1. การประกอบกิจการของท่าน มีน้ำเสียเกิดขึ้นหรือไม่
                  </div>
                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_one_main_one" id="checkbox-1_1" value="ไม่มี"
                          onclick="evaluateChild('category-2','hide')" v-model="evaluate.category_one_main_one" />
                        <label class="choice-1" for="checkbox-1_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_one_main_one" id="checkbox-1_2" value="มี"
                          onclick="evaluateChild('category-2','show')" v-model="evaluate.category_one_main_one" />
                        <label class="choice-2" for="checkbox-1_2">มี</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    2. วิธีการจัดการน้ำเสียที่เกิดขึ้น
                  </div>

                  <div class="card-body card-body-category">
                    <div id="category-2" class="card-body card-body-subcategory" :class="{
                      'd-flex': evaluate.category_one_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>

                        <table class="table">
                          <tbody>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_two_main_one" id="checkbox-2-1" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_two_main_one" :disabled="evaluate.category_one_main_one == 'ไม่มี'
                                      " />
                                  <label for="checkbox-2-1"></label>
                                </div>
                              </td>
                              <td colspan="6" class="table-column-2">
                                2.1 มีระบบบำบัดน้ำเสียภายในโรงงาน
                                (เลือกได้มากกว่า 1 ข้อ)
                              </td>
                            </tr>

                            <!-- /. Start 2.1.1 -->
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_two_sub_one_one_checkbox" id="checkbox-2-1-1_1c"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_one_one_checkbox
                                      " :disabled="evaluate.category_one_main_one ==
                                        'ไม่มี' ||
                                        evaluate.category_two_main_one == 'ไม่มี'
                                        " />
                                  <label for="checkbox-2-1-1_1c"></label>
                                </div>
                              </td>
                              <td colspan="5" class="table-column-2">
                                2.1.1 น้ำเสียปนเปื้อนสารอินทรีย์
                                (เลือกได้มากกว่า 1 ข้อ)
                              </td>
                            </tr>
                            <template v-for="(
itemSecondOneOne, itemIndex
                              ) in itemSecondOneOnes" :key="itemSecondOneOne.id">
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="4" class="table-column-2 system-header-category2">
                                  ระบบที่ {{ itemIndex + 1 }}
                                </td>
                                <td rowspan="4" class="table-column-8">
                                  <button type="button" class="btn btn-danger" @click="
                                    removeItemSecondOneOne(
                                      itemSecondOneOne.id
                                    )
                                    " v-if="
                                      evaluate.category_two_sub_one_one_checkbox !=
                                      'ไม่มี'
                                    ">
                                    <i class="bi bi-x-circle-fill"></i>
                                    ลบชุดข้อมูล ระบบที่ {{ itemIndex + 1 }}
                                  </button>
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="2" class="table-column-2 bl-category2">
                                  แหล่งที่มาของน้ำเสีย
                                </td>
                                <td class="table-column-3">
                                  <div class="icheck-material-green icheck-inline">
                                    <input type="radio" name="category_two_sub_one_one_radio"
                                      :id="`checkbox-2-1-1r_1_${itemIndex + 1}`" value="น้ำเสียจากกระบวนการผลิต"
                                      v-model="itemSecondOneOne.category_two_sub_one_one_radio
                                        " :disabled="evaluate.category_two_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_one_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_two_sub_one_one_checkbox ==
                                          'ไม่มี'
                                          " />
                                    <label class="choice-2" :for="`checkbox-2-1-1r_1_${itemIndex + 1
                                      }`">น้ำเสียจากกระบวนการผลิต</label>
                                  </div>
                                </td>
                                <td class="table-column-3 br-category2">
                                  <div class="icheck-material-green icheck-inline">
                                    <input type="radio" name="category_two_sub_one_one_radio"
                                      :id="`checkbox-2-1-1r_2_${itemIndex + 1}`" value="น้ำเสียจากการใช้น้ำของคนงาน"
                                      v-model="itemSecondOneOne.category_two_sub_one_one_radio
                                        " :disabled="evaluate.category_two_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_one_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_two_sub_one_one_checkbox ==
                                          'ไม่มี'
                                          " />
                                    <label class="choice-2" :for="`checkbox-2-1-1r_2_${itemIndex + 1
                                      }`">น้ำเสียจากการใช้น้ำของคนงาน</label>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="2" class="table-column-2 bl-category2"></td>
                                <td class="table-column-3">
                                  <div class="icheck-material-green icheck-inline">
                                    <input type="radio" name="category_two_sub_one_one_radio"
                                      :id="`checkbox-2-1-1r_3_${itemIndex + 1}`" value="น้ำเสียจากน้ำหล่อเย็น" v-model="itemSecondOneOne.category_two_sub_one_one_radio
                                        " :disabled="evaluate.category_two_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_one_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_two_sub_one_one_checkbox ==
                                          'ไม่มี'
                                          " />
                                    <label class="choice-2" :for="`checkbox-2-1-1r_3_${itemIndex + 1
                                      }`">น้ำเสียจากน้ำหล่อเย็น</label>
                                  </div>
                                </td>
                                <td class="table-column-3 br-category2">
                                  <div class="icheck-material-green icheck-inline">
                                    <input type="radio" name="category_two_sub_one_one_radio"
                                      :id="`checkbox-2-1-1r_4_${itemIndex + 1}`"
                                      value="น้ำเสียจากกิจกรรมอื่นๆ ในโรงงาน ระบุ" v-model="itemSecondOneOne.category_two_sub_one_one_radio
                                        " :disabled="evaluate.category_two_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_one_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_two_sub_one_one_checkbox ==
                                          'ไม่มี'
                                          " />
                                    <label class="choice-2" :for="`checkbox-2-1-1r_4_${itemIndex + 1
                                      }`">น้ำเสียจากกิจกรรมอื่นๆ ในโรงงาน
                                      ระบุ</label>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="2" class="table-column-2 bl-category2">
                                  <div class="d-flex">
                                    <div class="d-flex">
                                      ชนิดของระบบบำบัดน้ำเสีย
                                    </div>
                                  </div>
                                </td>
                                <td colspan="2" class="table-column-3 br-category2">
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_two_sub_one_one_textbox_one"
                                      class="form-control form-control-evaluate ms-2" v-model="itemSecondOneOne.category_two_sub_one_one_textbox_one
                                        " :disabled="evaluate.category_two_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_one_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_two_sub_one_one_checkbox ==
                                          'ไม่มี'
                                          " />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="2" class="table-column-2 bl-category2">
                                  ปริมาณน้ำเสียสูงสุดที่ระบบบำบัดน้ำเสียรองรับได้
                                  <sup>
                                    <div class="tooltip">
                                      <i class="bi bi-question-circle-fill"></i>
                                      <span class="tooltiptext">
                                        (คำอธิบาย :
                                        ต้องเป็นข้อมูลที่ได้จากค่าออกแบบระบบบำบัด
                                        น้ำเสีย)</span>
                                    </div>
                                  </sup>
                                </td>
                                <td class="table-column-3">
                                  <input type="text" name="category_two_sub_one_one_textbox_two"
                                    class="form-control form-control-evaluate text-end number" v-model="itemSecondOneOne.category_two_sub_one_one_textbox_two
                                      " placeholder="" data-v-min="0" :disabled="evaluate.category_two_main_one ==
                                        'ไม่มี' ||
                                        evaluate.category_one_main_one ==
                                        'ไม่มี' ||
                                        evaluate.category_two_sub_one_one_checkbox ==
                                        'ไม่มี'
                                        " />
                                </td>
                                <td class="table-column-4 br-category2">
                                  ลูกบาศก์เมตร/วัน
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="2" class="table-column-2 bl-category2">
                                  ค่าบีโอดี(Biochemical Oxygen Demand)
                                  สูงสุดที่ระบบบำบัดน้ำเสียรองรับได้
                                </td>
                                <td class="table-column-3">
                                  <input type="text" name="category_two_sub_one_one_textbox_three"
                                    class="form-control form-control-evaluate text-end number" v-model="itemSecondOneOne.category_two_sub_one_one_textbox_three
                                      " placeholder="" data-v-min="0" :disabled="evaluate.category_two_main_one ==
                                        'ไม่มี' ||
                                        evaluate.category_one_main_one ==
                                        'ไม่มี' ||
                                        evaluate.category_two_sub_one_one_checkbox ==
                                        'ไม่มี'
                                        " />
                                </td>
                                <td class="table-column-4 br-category2">
                                  มิลลิกรัม/ลิตร
                                </td>
                              </tr>
                              <tr class="tr-summary-margin-top">
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="2" class="summary table-column-2 bl-category2 bb-category2">
                                  ปริมาณความสกปรกในรูปบีโอดีก่อนเข้าระบบบำบัด
                                  (BOD Load of Influent) สูงสุด
                                </td>
                                <td class="summary table-column-4 text-end bb-category2">
                                  {{ itemSecondOneOnesBOD(itemSecondOneOne) }}
                                </td>
                                <td class="summary table-column-5 br-category2 bb-category2">
                                  กิโลกรัม/วัน
                                </td>
                              </tr>
                              <tr class="tr-summary-margin-bottom">
                                <td colspan="7"></td>
                              </tr>
                            </template>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <button type="button" class="btn btn-success w-100" @click="addItemSecondOneOne()" v-if="
                                  evaluate.category_two_sub_one_one_checkbox !=
                                  'ไม่มี'
                                ">
                                  <i class="bi bi-plus-circle-fill me-1"></i>
                                  เพิ่มชุดข้อมูล
                                </button>
                              </td>
                            </tr>
                            <tr class="tr-summary">
                              <td class="table-column-1"></td>
                              <td class="table-column-2"></td>
                              <td colspan="3" class="table-column-3">
                                <b>ปริมาณน้ำเสียสูงสุดรวม</b>
                              </td>
                              <td class="table-column-4 text-center">
                                <b>{{ evaluate.max_water_waste }}</b>
                              </td>
                              <td class="table-column-5">
                                <b>ลูกบาศก์เมตร/วัน</b>
                              </td>
                              <td class="table-column-5"></td>
                            </tr>
                            <tr class="tr-summary">
                              <td class="table-column-1"></td>
                              <td class="table-column-2"></td>
                              <td colspan="3" class="table-column-3">
                                <b>ปริมาณความสกปรกในรูปบีโอดีสูงสุดก่อนเข้าระบบบำบัด<br />(BOD
                                  Load of Influent)</b>
                              </td>
                              <td class="table-column-4 text-center">
                                <b>{{ evaluate.max_bod }}</b>
                              </td>
                              <td class="table-column-5">
                                <b>กิโลกรัม/วัน</b>
                              </td>
                              <td class="table-column-5"></td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                            <!-- /.End 2.1.1 -->

                            <!-- /. Start 2.1.2 -->
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_two_sub_one_two_checkbox" id="checkbox-2-1-2_1c"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_one_two_checkbox
                                      " :disabled="evaluate.category_one_main_one ==
                                        'ไม่มี' ||
                                        evaluate.category_two_main_one == 'ไม่มี'
                                        " />
                                  <label for="checkbox-2-1-2_1c"></label>
                                </div>
                              </td>
                              <td colspan="5" class="table-column-2">
                                2.1.2 ระบบบำบัดน้ำเสียปนเปื้อนโลหะหนัก
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                น้ำเสียมีสารหรือองค์ประกอบของสาร
                                ดังต่อไปนี้(เลือกได้มากกว่า 1 ข้อ)
                              </td>
                            </tr>
                            <template v-for="(
itemSecondOneTwo, itemIndex2
                              ) in itemSecondOneTwos" :key="itemSecondOneTwo.id">
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="4" class="table-column-2 system-header-category2">
                                  ระบบที่ {{ itemIndex2 + 1 }}
                                </td>
                                <td rowspan="4" class="table-column-8">
                                  <button type="button" class="btn btn-danger" @click="
                                    removeItemSecondOneTwo(
                                      itemSecondOneTwo.id
                                    )
                                    " v-if="
                                      evaluate.category_two_sub_one_two_checkbox !=
                                      'ไม่มี'
                                    ">
                                    <i class="bi bi-x-circle-fill"></i>
                                    ลบชุดข้อมูล ระบบที่ {{ itemIndex2 + 1 }}
                                  </button>
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-3 bl-category2">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_one"
                                      id="checkbox-2-1-2-1_c1" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_one
                                        " :disabled="evaluate.category_two_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_two_sub_one_two_checkbox ==
                                          'ไม่มี' ||
                                          evaluate.category_one_main_one ==
                                          'ไม่มี'
                                          " />
                                    <label for="checkbox-2-1-2-1_c1">สังกะสี(Zinc)</label>
                                  </div>
                                </td>
                                <td class="table-column-3">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_two"
                                      id="checkbox-2-1-2-1_c2" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_two
                                        " :disabled="evaluate.category_two_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_two_sub_one_two_checkbox ==
                                          'ไม่มี' ||
                                          evaluate.category_one_main_one ==
                                          'ไม่มี'
                                          " />
                                    <label for="checkbox-2-1-2-1_c2">แคดเมียม(Cadmium)</label>
                                  </div>
                                </td>
                                <td colspan="2" class="table-column-3 br-category2">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_three"
                                      id="checkbox-2-1-2-1_c3" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_three
                                        " :disabled="evaluate.category_two_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_two_sub_one_two_checkbox ==
                                          'ไม่มี' ||
                                          evaluate.category_one_main_one ==
                                          'ไม่มี'
                                          " />
                                    <label for="checkbox-2-1-2-1_c3">ไซยาไนด์(Cyanide)</label>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="4" class="table-column-3 bl-category2 br-category2">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_four"
                                      id="checkbox-2-1-2-1_c4" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_four
                                        " :disabled="evaluate.category_two_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_two_sub_one_two_checkbox ==
                                          'ไม่มี' ||
                                          evaluate.category_one_main_one ==
                                          'ไม่มี'
                                          " />
                                    <label for="checkbox-2-1-2-1_c4">ฟอสฟอรัสที่อยู่ในรูปของสารประกอบอินทรีย์(Organic
                                      Phosphorus Compounds)</label>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-3 bl-category2">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_five"
                                      id="checkbox-2-1-2-1_c5" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_five
                                        " :disabled="evaluate.category_two_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_two_sub_one_two_checkbox ==
                                          'ไม่มี' ||
                                          evaluate.category_one_main_one ==
                                          'ไม่มี'
                                          " />
                                    <label for="checkbox-2-1-2-1_c5">ตะกั่ว(Lead)</label>
                                  </div>
                                </td>
                                <td class="table-column-3">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_six"
                                      id="checkbox-2-1-2-1_c6" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_six
                                        " :disabled="evaluate.category_two_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_two_sub_one_two_checkbox ==
                                          'ไม่มี' ||
                                          evaluate.category_one_main_one ==
                                          'ไม่มี'
                                          " />
                                    <label for="checkbox-2-1-2-1_c6">ทองแดง(Copper)</label>
                                  </div>
                                </td>
                                <td colspan="2" class="table-column-3 br-category2">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_seven"
                                      id="checkbox-2-1-2-1_c7" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_seven
                                        " :disabled="evaluate.category_two_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_two_sub_one_two_checkbox ==
                                          'ไม่มี' ||
                                          evaluate.category_one_main_one ==
                                          'ไม่มี'
                                          " />
                                    <label for="checkbox-2-1-2-1_c7">บาเรียม(Barium)</label>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-3 bl-category2">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_eight"
                                      id="checkbox-2-1-2-1_c8" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_eight
                                        " :disabled="evaluate.category_two_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_two_sub_one_two_checkbox ==
                                          'ไม่มี' ||
                                          evaluate.category_one_main_one ==
                                          'ไม่มี'
                                          " />
                                    <label for="checkbox-2-1-2-1_c8">เซเลเนียม(Selenium)</label>
                                  </div>
                                </td>
                                <td class="table-column-3">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_nine"
                                      id="checkbox-2-1-2-1_c9" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_nine
                                        " :disabled="evaluate.category_two_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_two_sub_one_two_checkbox ==
                                          'ไม่มี' ||
                                          evaluate.category_one_main_one ==
                                          'ไม่มี'
                                          " />
                                    <label for="checkbox-2-1-2-1_c9">นิเกิล(Nickel)</label>
                                  </div>
                                </td>
                                <td colspan="2" class="table-column-3 br-category2">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_ten"
                                      id="checkbox-2-1-2-1_c10" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_ten
                                        " :disabled="evaluate.category_two_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_two_sub_one_two_checkbox ==
                                          'ไม่มี' ||
                                          evaluate.category_one_main_one ==
                                          'ไม่มี'
                                          " />
                                    <label for="checkbox-2-1-2-1_c10">แมงกานีส(Manganese)</label>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="4" class="table-column-3 bl-category2 br-category2">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_eleven"
                                      id="checkbox-2-1-2-1_c11" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_eleven
                                        " :disabled="evaluate.category_two_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_two_sub_one_two_checkbox ==
                                          'ไม่มี' ||
                                          evaluate.category_one_main_one ==
                                          'ไม่มี'
                                          " />
                                    <label for="checkbox-2-1-2-1_c11">โครเมียม วาเลนซี 6(Hexavalent
                                      Chromium)</label>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="4" class="table-column-3 bl-category2 br-category2">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_twelve"
                                      id="checkbox-2-1-2-1_c12" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_twelve
                                        " :disabled="evaluate.category_two_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_two_sub_one_two_checkbox ==
                                          'ไม่มี' ||
                                          evaluate.category_one_main_one ==
                                          'ไม่มี'
                                          " />
                                    <label for="checkbox-2-1-2-1_c12">อาร์ซินิคและสารประกอบอาร์ซินิค (Arsenic
                                      and its Compounds)</label>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="4" class="table-column-3 bl-category2 br-category2">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_thirteen"
                                      id="checkbox-2-1-2-1_c13" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_thirteen
                                        " :disabled="evaluate.category_two_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_two_sub_one_two_checkbox ==
                                          'ไม่มี' ||
                                          evaluate.category_one_main_one ==
                                          'ไม่มี'
                                          " />
                                    <label for="checkbox-2-1-2-1_c13">ปรอทและสารประกอบปรอท(Mercury and its
                                      Compounds)</label>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="2" class="table-column-2 bl-category2">
                                  <div class="d-flex">
                                    <div class="d-flex">
                                      ชนิดของระบบบำบัดน้ำเสีย
                                    </div>
                                  </div>
                                </td>
                                <td colspan="2" class="table-column-3 br-category2">
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_two_sub_one_one_textbox_one"
                                      class="form-control form-control-evaluate ms-2" v-model="itemSecondOneTwo.category_two_sub_one_one_textbox_one
                                        " :disabled="evaluate.category_two_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_two_sub_one_two_checkbox ==
                                          'ไม่มี' ||
                                          evaluate.category_one_main_one ==
                                          'ไม่มี'
                                          " />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="2" class="table-column-2 bl-category2 bb-category2 pb-2">
                                  ปริมาณน้ำเสียสูงสุดที่ระบบบำบัดน้ำเสียรองรับได้
                                  <sup>
                                    <div class="tooltip">
                                      <i class="bi bi-question-circle-fill"></i>
                                      <span class="tooltiptext">
                                        (คำอธิบาย :
                                        ต้องเป็นข้อมูลที่ได้จากค่าออกแบบระบบบำบัด
                                        น้ำเสีย)</span>
                                    </div>
                                  </sup>
                                </td>
                                <td class="table-column-3 bb-category2">
                                  <input type="text" name="category_two_sub_one_one_textbox_two"
                                    class="form-control form-control-evaluate text-end number" v-model="itemSecondOneTwo.category_two_sub_one_one_textbox_two
                                      " placeholder="" data-v-min="0" :disabled="evaluate.category_two_main_one ==
                                        'ไม่มี' ||
                                        evaluate.category_two_sub_one_two_checkbox ==
                                        'ไม่มี' ||
                                        evaluate.category_one_main_one == 'ไม่มี'
                                        " />
                                </td>
                                <td class="table-column-4 br-category2 bb-category2">
                                  ลูกบาศก์เมตร/วัน
                                </td>
                              </tr>
                              <tr class="tr-summary-margin-bottom">
                                <td colspan="7"></td>
                              </tr>
                            </template>

                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <button type="button" class="btn btn-success w-100" @click="addItemSecondOneTwo()" v-if="
                                  evaluate.category_two_sub_one_two_checkbox !=
                                  'ไม่มี'
                                ">
                                  <i class="bi bi-plus-circle-fill me-1"></i>
                                  เพิ่มชุดข้อมูล
                                </button>
                              </td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                            <!-- /.End 2.1.2 -->
                            <tr class="tr-summary">
                              <td class="table-column-1"></td>
                              <td class="table-column-2"></td>
                              <td colspan="3" class="table-column-3">
                                <b>ปริมาณน้ำเสียปนเปื้อนโลหะหนักสูงสุดรวม</b>
                              </td>
                              <td class="table-column-4 text-center">
                                <b>{{
                                  itemSecondOneTwoMaxWaste(itemSecondOneTwos)
                                  }}</b>
                              </td>
                              <td class="table-column-5">
                                <b>ลูกบาศก์เมตร/วัน</b>
                              </td>
                              <td class="table-column-5"></td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_two_main_two_checkbox" id="checkbox-2-2"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_main_two_checkbox
                                      " :disabled="evaluate.category_one_main_one == 'ไม่มี'
                                        " />
                                  <label for="checkbox-2-2"></label>
                                </div>
                              </td>
                              <td colspan="4" class="table-column-2">
                                2.2 มีการประกอบกิจการเกี่ยวกับการชุบโลหะ
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="6" class="table-column-2">
                                มีการใช้สารหรือองค์ประกอบของสาร ดังต่อไปนี้
                                (เลือกได้มากกว่า 1 ข้อ)
                              </td>
                            </tr>
                            <!-- Checkbox 2.2 -->
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_checkbox_one" id="checkbox-2-2_c1"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_one
                                      " :disabled="evaluate.category_two_main_two_checkbox ==
                                        'ไม่มี' ||
                                        evaluate.category_one_main_one == 'ไม่มี'
                                        " />
                                  <label for="checkbox-2-2_c1">สังกะสี(Zinc)</label>
                                </div>
                              </td>
                              <td class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_checkbox_two" id="checkbox-2-2_c2"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_two
                                      " :disabled="evaluate.category_two_main_two_checkbox ==
                                        'ไม่มี' ||
                                        evaluate.category_one_main_one == 'ไม่มี'
                                        " />
                                  <label for="checkbox-2-2_c2">แคดเมียม(Cadmium)</label>
                                </div>
                              </td>
                              <td colspan="2" class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_checkbox_three" id="checkbox-2-2_c3"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_three
                                      " :disabled="evaluate.category_two_main_two_checkbox ==
                                        'ไม่มี' ||
                                        evaluate.category_one_main_one == 'ไม่มี'
                                        " />
                                  <label for="checkbox-2-2_c3">ไซยาไนด์(Cyanide)</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_checkbox_four" id="checkbox-2-2_c4"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_four
                                      " :disabled="evaluate.category_two_main_two_checkbox ==
                                        'ไม่มี' ||
                                        evaluate.category_one_main_one == 'ไม่มี'
                                        " />
                                  <label for="checkbox-2-2_c4">ฟอสฟอรัสที่อยู่ในรูปของสารประกอบอินทรีย์(Organic
                                    Phosphorus Compounds)</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_checkbox_five" id="checkbox-2-2_c5"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_five
                                      " :disabled="evaluate.category_two_main_two_checkbox ==
                                        'ไม่มี' ||
                                        evaluate.category_one_main_one == 'ไม่มี'
                                        " />
                                  <label for="checkbox-2-2_c5">ตะกั่ว(Lead)</label>
                                </div>
                              </td>
                              <td class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_checkbox_six" id="checkbox-2-2_c6"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_six
                                      " :disabled="evaluate.category_two_main_two_checkbox ==
                                        'ไม่มี' ||
                                        evaluate.category_one_main_one == 'ไม่มี'
                                        " />
                                  <label for="checkbox-2-2_c6">ทองแดง(Copper)</label>
                                </div>
                              </td>
                              <td colspan="2" class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_checkbox_seven" id="checkbox-2-2_c7"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_seven
                                      " :disabled="evaluate.category_two_main_two_checkbox ==
                                        'ไม่มี' ||
                                        evaluate.category_one_main_one == 'ไม่มี'
                                        " />
                                  <label for="checkbox-2-2_c7">บาเรียม(Barium)</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_checkbox_eight" id="checkbox-2-2_c8"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_eight
                                      " :disabled="evaluate.category_two_main_two_checkbox ==
                                        'ไม่มี' ||
                                        evaluate.category_one_main_one == 'ไม่มี'
                                        " />
                                  <label for="checkbox-2-2_c8">เซเลเนียม(Selenium)</label>
                                </div>
                              </td>
                              <td class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_checkbox_nine" id="checkbox-2-2_c9"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_nine
                                      " :disabled="evaluate.category_two_main_two_checkbox ==
                                        'ไม่มี' ||
                                        evaluate.category_one_main_one == 'ไม่มี'
                                        " />
                                  <label for="checkbox-2-2_c9">นิเกิล(Nickel)</label>
                                </div>
                              </td>
                              <td colspan="2" class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_checkbox_ten" id="checkbox-2-2_c10"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_ten
                                      " :disabled="evaluate.category_two_main_two_checkbox ==
                                        'ไม่มี' ||
                                        evaluate.category_one_main_one == 'ไม่มี'
                                        " />
                                  <label for="checkbox-2-2_c10">แมงกานีส(Manganese)</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_one_checkbox_eleven"
                                    id="checkbox-2-2_c11" true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_eleven
                                      " :disabled="evaluate.category_two_main_two_checkbox ==
                                        'ไม่มี' ||
                                        evaluate.category_one_main_one == 'ไม่มี'
                                        " />
                                  <label for="checkbox-2-2_c11">โครเมียม วาเลนซี 6(Hexavalent
                                    Chromium)</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_checkbox_twelve"
                                    id="checkbox-2-2_c12" true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_twelve
                                      " :disabled="evaluate.category_two_main_two_checkbox ==
                                        'ไม่มี' ||
                                        evaluate.category_one_main_one == 'ไม่มี'
                                        " />
                                  <label for="checkbox-2-2_c12">อาร์ซินิคและสารประกอบอาร์ซินิค (Arsenic and
                                    its Compounds)</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_checkbox_thirteen"
                                    id="checkbox-2-2_c13" true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_thirteen
                                      " :disabled="evaluate.category_two_main_two_checkbox ==
                                        'ไม่มี' ||
                                        evaluate.category_one_main_one == 'ไม่มี'
                                        " />
                                  <label for="checkbox-2-2_c13">ปรอทและสารประกอบปรอท(Mercury and its
                                    Compounds)</label>
                                </div>
                              </td>
                            </tr>
                            <!-- Checkbox 2.2 End-->
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_two_main_three_checkbox" id="checkbox-2-3"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_main_three_checkbox
                                      " :disabled="evaluate.category_one_main_one == 'ไม่มี'
                                        " />
                                  <label for="checkbox-2-3"></label>
                                </div>
                              </td>
                              <td colspan="7" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">
                                    2.3 ส่งน้ำเสียไปบำบัดที่
                                  </div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_two_main_three_textbox_one"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_two_main_three_textbox_one
                                        " :disabled="evaluate.category_one_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_two_main_three_checkbox ==
                                          'ไม่มี'
                                          " />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_two_main_four_checkbox" id="checkbox-2-4"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_main_four_checkbox
                                      " :disabled="evaluate.category_one_main_one == 'ไม่มี'
                                        " />
                                  <label for="checkbox-2-4"></label>
                                </div>
                              </td>
                              <td colspan="7" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">2.4 อื่นๆ</div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_two_main_four_textbox_one"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_two_main_four_textbox_one
                                        " :disabled="evaluate.category_one_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_two_main_four_checkbox ==
                                          'ไม่มี'
                                          " />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    3.
                    โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการผลิตน้ำตาลทรายดิบ
                    น้ำตาลทรายขาว น้ำตาลทรายขาวให้บริสุทธิ์ น้ำตาลกลูโคส
                    เดกซ์โทรส ฟรักโทส หรือผลิตภัณฑ์อื่นที่คล้ายคลึงกัน หรือไม่
                  </div>
                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_three_main_one" id="checkbox-3_1" value="ไม่มี"
                          onclick="evaluateChild('category-3','hide')" v-model="evaluate.category_three_main_one" />
                        <label class="choice-1" for="checkbox-3_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_three_main_one" id="checkbox-3_2" value="มี"
                          onclick="evaluateChild('category-3','show')" v-model="evaluate.category_three_main_one" />
                        <label class="choice-2" for="checkbox-3_2">มี</label>
                      </div>
                    </div>

                    <div id="category-3" class="card-body card-body-subcategory" :class="{
                      'd-flex': evaluate.category_three_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_three_sub_one" id="checkbox-3-1" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_three_sub_one" :disabled="evaluate.category_three_main_one ==
                                      'ไม่มี'
                                      " />
                                  <label for="checkbox-3-1"></label>
                                </div>
                              </td>
                              <td colspan="4" class="table-column-2">
                                การผลิตน้ำตาลทรายดิบ
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_three_sub_two" id="checkbox-3-2" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_three_sub_two" :disabled="evaluate.category_three_main_one ==
                                      'ไม่มี'
                                      " />
                                  <label for="checkbox-3-2"></label>
                                </div>
                              </td>
                              <td colspan="4" class="table-column-2">
                                การผลิตน้ำตาลทรายขาว
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_three_sub_three" id="checkbox-3-3"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_three_sub_three"
                                    :disabled="evaluate.category_three_main_one ==
                                      'ไม่มี'
                                      " />
                                  <label for="checkbox-3-3"></label>
                                </div>
                              </td>
                              <td colspan="4" class="table-column-2">
                                การผลิตน้ำตาลทรายขาวให้บริสุทธิ์
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_three_sub_four" id="checkbox-3-4"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_three_sub_four"
                                    :disabled="evaluate.category_three_main_one ==
                                      'ไม่มี'
                                      " />
                                  <label for="checkbox-3-4"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                การผลิตน้ำตาลกลูโคส
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_three_sub_four_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_three_sub_four_textbox_one
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_three_main_one ==
                                      'ไม่มี' ||
                                      evaluate.category_three_sub_four == 'ไม่มี'
                                      " :required="evaluate.category_three_sub_four != 'ไม่มี'
                                        " />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_three_sub_five" id="checkbox-3-5"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_three_sub_five"
                                    :disabled="evaluate.category_three_main_one ==
                                      'ไม่มี'
                                      " />
                                  <label for="checkbox-3-5"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                การผลิตน้ำตาลเดกซ์โทรส
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">
                                      คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_three_sub_five_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_three_sub_five_textbox_one
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_three_main_one ==
                                      'ไม่มี' ||
                                      evaluate.category_three_sub_five == 'ไม่มี'
                                      " />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_three_sub_six" id="checkbox-3-6" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_three_sub_six" :disabled="evaluate.category_three_main_one ==
                                      'ไม่มี'
                                      " :required="evaluate.category_three_sub_six != 'ไม่มี'
                                        " />
                                  <label for="checkbox-3-6"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                การผลิตน้ำตาลฟรักโทส
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">
                                      คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_three_sub_six_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_three_sub_six_textbox_one
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_three_main_one ==
                                      'ไม่มี' ||
                                      evaluate.category_three_sub_six == 'ไม่มี'
                                      " :required="evaluate.category_three_sub_six != 'ไม่มี'
                                        " />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_three_sub_seven" id="checkbox-3-7"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_three_sub_seven"
                                    :disabled="evaluate.category_three_main_one ==
                                      'ไม่มี'
                                      " />
                                  <label for="checkbox-3-7"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                <div class="d-flex flex-column">
                                  <div>การผลิตผลิตภัณฑ์อื่นที่คล้ายคลึงกัน</div>
                                  <div class="d-flex">
                                    ระบุ
                                    <input type="text" name="category_three_sub_seven_one"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_three_sub_seven_one
                                        " :disabled="evaluate.category_three_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_three_sub_seven ==
                                          'ไม่มี'
                                          " :required="evaluate.category_three_sub_seven !=
                                            'ไม่มี'
                                            " />
                                  </div>
                                </div>
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">
                                      คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_three_sub_seven_two"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_three_sub_seven_two
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_three_main_one ==
                                      'ไม่มี' ||
                                      evaluate.category_three_sub_seven == 'ไม่มี'
                                      " :required="evaluate.category_three_sub_seven != 'ไม่มี'
                                        " />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    4. โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการผลิตสุรา
                    แอลกอฮอล์ ไวน์ เบียร์ หรือไม่
                  </div>
                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_four_main_one" id="checkbox-4_1" value="ไม่มี"
                          onclick="evaluateChild('category-4','hide')" v-model="evaluate.category_four_main_one" />
                        <label class="choice-1" for="checkbox-4_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_four_main_one" id="checkbox-4_2" value="มี"
                          onclick="evaluateChild('category-4','show')" v-model="evaluate.category_four_main_one" />
                        <label class="choice-2" for="checkbox-4_2">มี</label>
                      </div>
                    </div>


                    <div id="category-4" class="card-body card-body-subcategory" :class="{
                      'd-flex': evaluate.category_four_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_four_sub_one" id="checkbox-4-1" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_four_sub_one" :disabled="evaluate.category_four_main_one == 'ไม่มี'
                                      " />
                                  <label for="checkbox-4-1"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                การผลิตสุรา (คิดเทียบที่ 24 ดีกรี)
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_four_sub_one_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_four_sub_one_textbox_one
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_four_main_one ==
                                      'ไม่มี' ||
                                      evaluate.category_four_sub_one == 'ไม่มี'
                                      " :required="evaluate.category_four_sub_one != 'ไม่มี'
                                        " />
                              </td>
                              <td class="table-column-5">ลิตร/เดือน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_four_sub_two" id="checkbox-4-2" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_four_sub_two" :disabled="evaluate.category_four_main_one == 'ไม่มี'
                                      " />
                                  <label for="checkbox-4-2"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                การผลิตแอลกอฮอล์ (คิดเทียบที่ 24 ดีกรี)
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_four_sub_two_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_four_sub_two_textbox_one
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_four_main_one ==
                                      'ไม่มี' ||
                                      evaluate.category_four_sub_two == 'ไม่มี'
                                      " :required="evaluate.category_four_sub_two != 'ไม่มี'
                                        " />
                              </td>
                              <td class="table-column-5">ลิตร/เดือน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_four_sub_three" id="checkbox-4-3"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_four_sub_three"
                                    :disabled="evaluate.category_four_main_one == 'ไม่มี'
                                      " />
                                  <label for="checkbox-4-3"></label>
                                </div>
                              </td>
                              <td class="table-column-2">การผลิตไวน์</td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_four_sub_three_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_four_sub_three_textbox_one
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_four_main_one ==
                                      'ไม่มี' ||
                                      evaluate.category_four_sub_three == 'ไม่มี'
                                      " :required="evaluate.category_four_sub_three != 'ไม่มี'
                                        " />
                              </td>
                              <td class="table-column-5">ลิตร/เดือน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_four_sub_four" id="checkbox-4-4" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_four_sub_four" :disabled="evaluate.category_four_main_one == 'ไม่มี'
                                      " />
                                  <label for="checkbox-4-4"></label>
                                </div>
                              </td>
                              <td class="table-column-2">การผลิตเบียร์</td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_four_sub_four_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_four_sub_four_textbox_one
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_four_main_one ==
                                      'ไม่มี' ||
                                      evaluate.category_four_sub_four == 'ไม่มี'
                                      " :required="evaluate.category_four_sub_four != 'ไม่มี'
                                        " />
                              </td>
                              <td class="table-column-5">ลิตร/เดือน</td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    5.
                    โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการผลิตเยื่อจากไม้หรือวัสดุอื่น
                    หรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_five_main_one" id="checkbox-5_1" value="ไม่มี"
                          onclick="evaluateChild('category-5','hide')" v-model="evaluate.category_five_main_one" />
                        <label class="choice-1" for="checkbox-5_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_five_main_one" id="checkbox-5_2" value="มี"
                          onclick="evaluateChild('category-5','show')" v-model="evaluate.category_five_main_one" />
                        <label class="choice-2" for="checkbox-5_2">มี</label>
                      </div>
                    </div>


                    <div id="category-5" class="card-body card-body-subcategory" :class="{
                      'd-flex': evaluate.category_five_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_five_sub_one" id="checkbox-5-1" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_five_sub_one" :disabled="evaluate.category_five_main_one == 'ไม่มี'
                                      " />
                                  <label for="checkbox-5-1"></label>
                                </div>
                              </td>
                              <td class="table-column-2">การผลิตเยื่อจากไม้</td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_five_sub_one_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_five_sub_one_textbox_one
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_five_main_one ==
                                      'ไม่มี' ||
                                      evaluate.category_five_sub_one == 'ไม่มี'
                                      " :required="evaluate.category_five_sub_one != 'ไม่มี'
                                        " />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_five_sub_two" id="checkbox-5-2" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_five_sub_two" :disabled="evaluate.category_five_main_one == 'ไม่มี'
                                      " />
                                  <label for="checkbox-5-2"></label>
                                </div>
                              </td>
                              <td colspan="4" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">
                                    การผลิตเยื่อจากวัสดุอื่น
                                  </div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_five_sub_two_textbox_one"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_five_sub_two_textbox_one
                                        " :disabled="evaluate.category_five_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_five_sub_two ==
                                          'ไม่มี'
                                          " :required="evaluate.category_five_sub_two !=
                                            'ไม่มี'
                                            " />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">
                                    การผลิตเยื่อจากวัสดุอื่น
                                  </div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_five_sub_two_textbox_two"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_five_sub_two_textbox_two
                                        " :disabled="evaluate.category_five_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_five_sub_two ==
                                          'ไม่มี'
                                          " />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">
                                    การผลิตเยื่อจากวัสดุอื่น
                                  </div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_five_sub_two_textbox_three"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_five_sub_two_textbox_three
                                        " :disabled="evaluate.category_five_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_five_sub_two ==
                                          'ไม่มี'
                                          " />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-2"></td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">
                                      คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_five_sub_two_textbox_four"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_five_sub_two_textbox_four
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_five_main_one ==
                                      'ไม่มี' ||
                                      evaluate.category_five_sub_two == 'ไม่มี'
                                      " :required="evaluate.category_five_sub_two != 'ไม่มี'
                                        " />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    6.
                    โรงงานของท่านมีการประกอบกิจการเกี่ยวกับปิโตรเคมีที่มีกระบวนการผลิตทางเคมี
                    หรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_six_main_one" id="checkbox-6_1" value="ไม่มี"
                          onclick="evaluateChild('category-6','hide')" v-model="evaluate.category_six_main_one" />
                        <label class="choice-1" for="checkbox-6_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_six_main_one" id="checkbox-6_2" value="มี"
                          onclick="evaluateChild('category-6','show')" v-model="evaluate.category_six_main_one" />
                        <label class="choice-2" for="checkbox-6_2">มี</label>
                      </div>
                    </div>


                    <div id="category-6" class="card-body card-body-subcategory" :class="{
                      'd-flex': evaluate.category_six_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-2"></td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">
                                      คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_six_sub_one_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_six_sub_one_textbox_one
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_six_main_one == 'ไม่มี'
                                      " :required="evaluate.category_six_main_one != 'ไม่มี'
                                        " />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category" style="">
                  <div class="card-header card-header-category">
                    7. โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการผลิต
                    คลอ-แอลคาไลน์ที่ใช้โซเดียมคลอไรด์(NaCl)
                    เป็นวัตถุดิบในการผลิตโซเดียมคาร์บอเนต(Na<sub>2</sub>CO<sub>3</sub>)
                    โซเดียมไฮดรอกไซด์(NaOH) กรดไฮโดรคลอริก(HCl)
                    คลอรีน(Cl<sub>2</sub>) โซเดียมไฮโพคลอไรด์(NaOCl)
                    และปูนคลอรีน(Bleaching Powder) หรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_seven_main_one" id="checkbox-7_1" value="ไม่มี"
                          onclick="evaluateChild('category-7','hide')" v-model="evaluate.category_seven_main_one" />
                        <label class="choice-1" for="checkbox-7_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_seven_main_one" id="checkbox-7_2" value="มี"
                          onclick="evaluateChild('category-7','show')" v-model="evaluate.category_seven_main_one" />
                        <label class="choice-2" for="checkbox-7_2">มี</label>
                      </div>
                    </div>


                    <div id="category-7" class="card-body card-body-subcategory" :class="{
                      'd-flex': evaluate.category_seven_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_seven_sub_one" id="checkbox-7-1" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_seven_sub_one" :disabled="evaluate.category_seven_main_one ==
                                      'ไม่มี'
                                      " />
                                  <label for="checkbox-7-1"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                โซเดียมคาร์บอเนต(Na<sub>2</sub>CO<sub>3</sub>)
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_seven_sub_one_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_seven_sub_one_textbox_one
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_seven_main_one ==
                                      'ไม่มี' ||
                                      evaluate.category_seven_sub_one == 'ไม่มี'
                                      " :required="evaluate.category_seven_sub_one != 'ไม่มี'
                                        " />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_seven_sub_two" id="checkbox-7-2" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_seven_sub_two" :disabled="evaluate.category_seven_main_one ==
                                      'ไม่มี'
                                      " />
                                  <label for="checkbox-7-2"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                โซเดียมไฮดรอกไซด์(NaOH)
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_seven_sub_two_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_seven_sub_two_textbox_one
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_seven_main_one ==
                                      'ไม่มี' ||
                                      evaluate.category_seven_sub_two == 'ไม่มี'
                                      " :required="evaluate.category_seven_sub_two != 'ไม่มี'
                                        " />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_seven_sub_three" id="checkbox-7-3"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_seven_sub_three"
                                    :disabled="evaluate.category_seven_main_one ==
                                      'ไม่มี'
                                      " />
                                  <label for="checkbox-7-3"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                กรดไฮโดรคลอริก(HCl)
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_seven_sub_three_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_seven_sub_three_textbox_one
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_seven_main_one ==
                                      'ไม่มี' ||
                                      evaluate.category_seven_sub_three == 'ไม่มี'
                                      " :required="evaluate.category_seven_sub_three != 'ไม่มี'
                                        " />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_seven_sub_four" id="checkbox-7-4"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_seven_sub_four"
                                    :disabled="evaluate.category_seven_main_one ==
                                      'ไม่มี'
                                      " />
                                  <label for="checkbox-7-4"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                คลอรีน(Cl<sub>2</sub>)
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_seven_sub_four_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_seven_sub_four_textbox_one
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_seven_main_one ==
                                      'ไม่มี' ||
                                      evaluate.category_seven_sub_four == 'ไม่มี'
                                      " :required="evaluate.category_seven_sub_four != 'ไม่มี'
                                        " />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_seven_sub_five" id="checkbox-7-5"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_seven_sub_five"
                                    :disabled="evaluate.category_seven_main_one ==
                                      'ไม่มี'
                                      " />
                                  <label for="checkbox-7-5"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                โซเดียมไฮโพคลอไรด์(NaOCl)
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_seven_sub_five_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_seven_sub_five_textbox_one
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_seven_main_one ==
                                      'ไม่มี' ||
                                      evaluate.category_seven_sub_five == 'ไม่มี'
                                      " :required="evaluate.category_seven_sub_five != 'ไม่มี'
                                        " />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_seven_sub_six" id="checkbox-7-6" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_seven_sub_six" :disabled="evaluate.category_seven_main_one ==
                                      'ไม่มี'
                                      " />
                                  <label for="checkbox-7-6"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                ปูนคลอรีน(Bleaching Powder)
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_seven_sub_six_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_seven_sub_six_textbox_one
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_seven_main_one ==
                                      'ไม่มี' ||
                                      evaluate.category_seven_sub_six == 'ไม่มี'
                                      " :required="evaluate.category_seven_sub_six != 'ไม่มี'
                                        " />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr class="tr-summary-margin-top">
                              <td colspan="5"></td>
                            </tr>
                            <tr class="tr-summary">
                              <td class="table-column-1"></td>
                              <td class="table-column-2"></td>
                              <td class="table-column-3">
                                <b>กำลังการผลิตรวม </b>
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4 text-center">
                                <b>{{ sumCategorySeven }}</b>
                              </td>
                              <td class="table-column-5"><b>ตัน/วัน</b></td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    8.
                    โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการผลิตสารออกฤทธิ์หรือสารที่ใช้ป้องกันหรือกำจัดศัตรูพืช
                    หรือสัตว์โดยใช้กระบวนการเคมีทุกขนาด
                    หรือประกอบกิจการเกี่ยวกับการผลิตปุ๋ยเคมี โดยใช้กระบวนการเคมี
                    หรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_eight_main_one" id="checkbox-8_1" value="ไม่มี"
                          onclick="evaluateChild('category-8','hide')" v-model="evaluate.category_eight_main_one" />
                        <label class="choice-1" for="checkbox-8_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_eight_main_one" id="checkbox-8_2" value="มี"
                          onclick="evaluateChild('category-8','show')" v-model="evaluate.category_eight_main_one" />
                        <label class="choice-2" for="checkbox-8_2">มี</label>
                      </div>
                    </div>

                    <div id="category-8" class="card-body card-body-subcategory" :class="{
                      'd-flex': evaluate.category_eight_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_eight_sub_one" id="checkbox-8-1" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_eight_sub_one" :disabled="evaluate.category_eight_main_one ==
                                      'ไม่มี'
                                      " />
                                  <label for="checkbox-8-1"></label>
                                </div>
                              </td>
                              <td colspan="4" class="table-column-2">
                                การผลิตสารออกฤทธิ์หรือสารที่ใช้ป้องกันหรือกำจัดศัตรูพืชหรือสัตว์
                                โดยใช้กระบวนการเคมี
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_eight_sub_two" id="checkbox-8-2" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_eight_sub_two" :disabled="evaluate.category_eight_main_one ==
                                      'ไม่มี'
                                      " />
                                  <label for="checkbox-8-2"></label>
                                </div>
                              </td>
                              <td colspan="4" class="table-column-2">
                                การผลิตปุ๋ยเคมี
                              </td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    9. โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการผลิตยาง
                    เรซินสังเคราะห์ ยางอีลาสโตเมอร์ พลาสติก
                    หรือเส้นใยสังเคราะห์ซึ่งมิใช่ใยแก้ว หรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_nine_main_one" id="checkbox-9_1" value="ไม่มี"
                          onclick="evaluateChild('category-9','hide')" v-model="evaluate.category_nine_main_one" />
                        <label class="choice-1" for="checkbox-9_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_nine_main_one" id="checkbox-9_2" value="มี"
                          onclick="evaluateChild('category-9','show')" v-model="evaluate.category_nine_main_one" />
                        <label class="choice-2" for="checkbox-9_2">มี</label>
                      </div>
                    </div>

                    <div id="category-9" class="card-body card-body-subcategory" :class="{
                      'd-flex': evaluate.category_nine_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_nine_sub_two" id="checkbox-9-1" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_nine_sub_two" :disabled="evaluate.category_nine_main_one == 'ไม่มี'
                                      " />
                                  <label for="checkbox-9-1"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                การผลิตเรซินสังเคราะห์
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_nine_sub_two_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_nine_sub_two_textbox_one
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_nine_main_one ==
                                      'ไม่มี' ||
                                      evaluate.category_nine_sub_two == 'ไม่มี'
                                      " :required="evaluate.category_nine_sub_two != 'ไม่มี'
                                        " />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_nine_sub_three" id="checkbox-9-2"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_nine_sub_three"
                                    :disabled="evaluate.category_nine_main_one == 'ไม่มี'
                                      " />
                                  <label for="checkbox-9-2"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                การผลิตยางอีลาสโตเมอร์
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_nine_sub_three_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_nine_sub_three_textbox_one
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_nine_main_one ==
                                      'ไม่มี' ||
                                      evaluate.category_nine_sub_three == 'ไม่มี'
                                      " :required="evaluate.category_nine_sub_three != 'ไม่มี'
                                        " />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_nine_sub_four" id="checkbox-9-3" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_nine_sub_four" :disabled="evaluate.category_nine_main_one == 'ไม่มี'
                                      " />
                                  <label for="checkbox-9-3"></label>
                                </div>
                              </td>
                              <td class="table-column-2">การผลิตพลาสติก</td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_nine_sub_four_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_nine_sub_four_textbox_one
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_nine_main_one ==
                                      'ไม่มี' ||
                                      evaluate.category_nine_sub_four == 'ไม่มี'
                                      " :required="evaluate.category_nine_sub_four != 'ไม่มี'
                                        " />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_nine_sub_five" id="checkbox-9-4" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_nine_sub_five" :disabled="evaluate.category_nine_main_one == 'ไม่มี'
                                      " />
                                  <label for="checkbox-9-4"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                การผลิตเส้นใยสังเคราะห์ซึ่งมิใช่ใยแก้ว
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_nine_sub_five_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_nine_sub_five_textbox_one
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_nine_main_one ==
                                      'ไม่มี' ||
                                      evaluate.category_nine_sub_five == 'ไม่มี'
                                      " :required="evaluate.category_nine_sub_five != 'ไม่มี'
                                        " />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    10.
                    โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการกลั่นน้ำมันปิโตรเลียม
                    หรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_ten_main_one" id="checkbox-10_1" value="ไม่มี"
                          v-model="evaluate.category_ten_main_one" />
                        <label class="choice-1" for="checkbox-10_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_ten_main_one" id="checkbox-10_2" value="มี"
                          v-model="evaluate.category_ten_main_one" />
                        <label class="choice-2" for="checkbox-10_2">มี</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    11. โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการผลิตปูนซีเมนต์
                    หรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_eleven_main_one" id="checkbox-11_1" value="ไม่มี"
                          v-model="evaluate.category_eleven_main_one" />
                        <label class="choice-1" for="checkbox-11_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_eleven_main_one" id="checkbox-11_2" value="มี"
                          v-model="evaluate.category_eleven_main_one" />
                        <label class="choice-2" for="checkbox-11_2">มี</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    12.
                    โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการผลิตเหล็กหรือเหล็กกล้าหรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_twelveteen_main_one" id="checkbox-12_1" value="ไม่มี"
                          onclick="evaluateChild('category-12','hide')"
                          v-model="evaluate.category_twelveteen_main_one" />
                        <label class="choice-1" for="checkbox-12_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_twelveteen_main_one" id="checkbox-12_2" value="มี"
                          onclick="evaluateChild('category-12','show')"
                          v-model="evaluate.category_twelveteen_main_one" />
                        <label class="choice-2" for="checkbox-12_2">มี</label>
                      </div>
                    </div>

                    <div id="category-12" class="card-body card-body-subcategory" :class="{
                      'd-flex': evaluate.category_twelveteen_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_twelveteen_sub_one" id="checkbox-12-1"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_twelveteen_sub_one
                                      " :disabled="evaluate.category_twelveteen_main_one ==
                                        'ไม่มี'
                                        " />
                                  <label for="checkbox-12-1"></label>
                                </div>
                              </td>
                              <td class="table-column-2">การผลิตเหล็ก</td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_twelveteen_sub_one_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_twelveteen_sub_one_textbox_one
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_twelveteen_main_one ==
                                      'ไม่มี' ||
                                      evaluate.category_twelveteen_sub_one ==
                                      'ไม่มี'
                                      " :required="evaluate.category_twelveteen_sub_one !=
                                        'ไม่มี'
                                        " />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-2">
                                มีน้ำเสียเกิดขึ้นหรือไม่
                              </td>
                              <td class="table-column-3"></td>
                              <td class="table-column-4">
                                <div class="icheck-material-deeporange icheck-inline">
                                  <input type="radio" name="category_twelveteen_sub_one_radio_one"
                                    id="checkbox-12-1r1_1" value="ไม่มี" v-model="evaluate.category_twelveteen_sub_one_radio_one
                                      " :disabled="evaluate.category_twelveteen_main_one ==
                                        'ไม่มี' ||
                                        evaluate.category_twelveteen_sub_one ==
                                        'ไม่มี'
                                        " />
                                  <label class="choice-1" for="checkbox-12-1r1_1">ไม่มี</label>
                                </div>
                                <div class="icheck-material-green icheck-inline ms-have">
                                  <input type="radio" name="category_twelveteen_sub_one_radio_one"
                                    id="checkbox-12-1r1_2" value="มี" v-model="evaluate.category_twelveteen_sub_one_radio_one
                                      " :disabled="evaluate.category_twelveteen_main_one ==
                                        'ไม่มี' ||
                                        evaluate.category_twelveteen_sub_one ==
                                        'ไม่มี'
                                        " />
                                  <label class="choice-2" for="checkbox-12-1r1_2">มี</label>
                                </div>
                              </td>
                              <td class="table-column-5"></td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_twelveteen_sub_two" id="checkbox-12-2"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_twelveteen_sub_two
                                      " :disabled="evaluate.category_twelveteen_main_one ==
                                        'ไม่มี'
                                        " />
                                  <label for="checkbox-12-2"></label>
                                </div>
                              </td>
                              <td class="table-column-2">การผลิตเหล็กกล้า</td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_twelveteen_sub_two_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_twelveteen_sub_two_textbox_one
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_twelveteen_main_one ==
                                      'ไม่มี' ||
                                      evaluate.category_twelveteen_sub_two ==
                                      'ไม่มี'
                                      " :required="evaluate.category_twelveteen_sub_two !=
                                        'ไม่มี'
                                        " />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-2">
                                มีน้ำเสียเกิดขึ้นหรือไม่
                              </td>
                              <td class="table-column-3"></td>
                              <td class="table-column-4">
                                <div class="icheck-material-deeporange icheck-inline">
                                  <input type="radio" name="category_twelveteen_sub_two_radio_one"
                                    id="checkbox-12-2r1_1" value="ไม่มี" v-model="evaluate.category_twelveteen_sub_two_radio_one
                                      " :disabled="evaluate.category_twelveteen_main_one ==
                                        'ไม่มี' ||
                                        evaluate.category_twelveteen_sub_two ==
                                        'ไม่มี'
                                        " />
                                  <label class="choice-1" for="checkbox-12-2r1_1">ไม่มี</label>
                                </div>
                                <div class="icheck-material-green icheck-inline ms-have">
                                  <input type="radio" name="category_twelveteen_sub_two_radio_one"
                                    id="checkbox-12-2r1_2" value="มี" v-model="evaluate.category_twelveteen_sub_two_radio_one
                                      " :disabled="evaluate.category_twelveteen_main_one ==
                                        'ไม่มี' ||
                                        evaluate.category_twelveteen_sub_two ==
                                        'ไม่มี'
                                        " />
                                  <label class="choice-2" for="checkbox-12-2r1_2">มี</label>
                                </div>
                              </td>
                              <td class="table-column-5"></td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    13. โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการถลุง
                    หรือหลอมโลหะ ซึ่งไม่ใช่อุตสาหกรรมเหล็ก หรือเหล็กกล้า หรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_thirdteen_main_one" id="checkbox-13_1" value="ไม่มี"
                          onclick="evaluateChild('category-13','hide')"
                          v-model="evaluate.category_thirdteen_main_one" />
                        <label class="choice-1" for="checkbox-13_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_thirdteen_main_one" id="checkbox-13_2" value="มี"
                          onclick="evaluateChild('category-13','show')"
                          v-model="evaluate.category_thirdteen_main_one" />
                        <label class="choice-2" for="checkbox-13_2">มี</label>
                      </div>
                    </div>


                    <div id="category-13" class="card-body card-body-subcategory" :class="{
                      'd-flex': evaluate.category_thirdteen_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_thirdteen_sub_one" id="checkbox-13-1"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_thirdteen_sub_one
                                      " :disabled="evaluate.category_thirdteen_main_one ==
                                        'ไม่มี'
                                        " />
                                  <label for="checkbox-13-1"></label>
                                </div>
                              </td>
                              <td colspan="4" class="table-column-2">
                                การถลุงโลหะ
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">ระบุชนิดของโลหะ</div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_thirdteen_sub_one_textbox_one"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_thirdteen_sub_one_textbox_one
                                        " :disabled="evaluate.category_thirdteen_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_thirdteen_sub_one ==
                                          'ไม่มี'
                                          " :required="evaluate.category_thirdteen_sub_one !=
                                            'ไม่มี'
                                            " />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">ระบุชนิดของโลหะ</div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_thirdteen_sub_one_textbox_two"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_thirdteen_sub_one_textbox_two
                                        " :disabled="evaluate.category_thirdteen_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_thirdteen_sub_one ==
                                          'ไม่มี'
                                          " />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">ระบุชนิดของโลหะ</div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_thirdteen_sub_one_textbox_three"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_thirdteen_sub_one_textbox_three
                                        " :disabled="evaluate.category_thirdteen_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_thirdteen_sub_one ==
                                          'ไม่มี'
                                          " />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-2"></td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">
                                      คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_thirdteen_sub_one_textbox_four"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_thirdteen_sub_one_textbox_four
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_thirdteen_main_one ==
                                      'ไม่มี' ||
                                      evaluate.category_thirdteen_sub_one ==
                                      'ไม่มี'
                                      " :required="evaluate.category_thirdteen_sub_one !=
                                        'ไม่มี'
                                        " />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-2">
                                มีน้ำเสียเกิดขึ้นหรือไม่
                              </td>
                              <td class="table-column-3"></td>
                              <td class="table-column-4">
                                <div class="icheck-material-deeporange icheck-inline">
                                  <input type="radio" name="category_thirdteen_sub_one_radio_one" id="checkbox-13-1r1_1"
                                    value="ไม่มี" v-model="evaluate.category_thirdteen_sub_one_radio_one
                                      " :disabled="evaluate.category_thirdteen_main_one ==
                                        'ไม่มี' ||
                                        evaluate.category_thirdteen_sub_one ==
                                        'ไม่มี'
                                        " />
                                  <label class="choice-1" for="checkbox-13-1r1_1">ไม่มี</label>
                                </div>
                                <div class="icheck-material-green icheck-inline ms-have">
                                  <input type="radio" name="category_thirdteen_sub_one_radio_one" id="checkbox-13-1r1_2"
                                    value="มี" v-model="evaluate.category_thirdteen_sub_one_radio_one
                                      " :disabled="evaluate.category_thirdteen_main_one ==
                                        'ไม่มี' ||
                                        evaluate.category_thirdteen_sub_one ==
                                        'ไม่มี'
                                        " />
                                  <label class="choice-2" for="checkbox-13-1r1_2">มี</label>
                                </div>
                              </td>
                              <td class="table-column-5"></td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_thirdteen_sub_two" id="checkbox-13-2"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_thirdteen_sub_two
                                      " :disabled="evaluate.category_thirdteen_main_one ==
                                        'ไม่มี'
                                        " />
                                  <label for="checkbox-13-2"></label>
                                </div>
                              </td>
                              <td colspan="4" class="table-column-2">
                                การหลอมโลหะ
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">ระบุชนิดของโลหะ</div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_thirdteen_sub_two_textbox_one"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_thirdteen_sub_two_textbox_one
                                        " :disabled="evaluate.category_thirdteen_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_thirdteen_sub_two ==
                                          'ไม่มี'
                                          " :required="evaluate.category_thirdteen_sub_two !=
                                            'ไม่มี'
                                            " />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">ระบุชนิดของโลหะ</div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_thirdteen_sub_two_textbox_two"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_thirdteen_sub_two_textbox_two
                                        " :disabled="evaluate.category_thirdteen_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_thirdteen_sub_two ==
                                          'ไม่มี'
                                          " />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">ระบุชนิดของโลหะ</div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_thirdteen_sub_two_textbox_three"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_thirdteen_sub_two_textbox_three
                                        " :disabled="evaluate.category_thirdteen_main_one ==
                                          'ไม่มี' ||
                                          evaluate.category_thirdteen_sub_two ==
                                          'ไม่มี'
                                          " />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-2"></td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">
                                      คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_thirdteen_sub_two_textbox_four"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_thirdteen_sub_two_textbox_four
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_thirdteen_main_one ==
                                      'ไม่มี' ||
                                      evaluate.category_thirdteen_sub_two ==
                                      'ไม่มี'
                                      " :required="evaluate.category_thirdteen_sub_two !=
                                        'ไม่มี'
                                        " />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-2">
                                มีน้ำเสียเกิดขึ้นหรือไม่
                              </td>
                              <td class="table-column-3"></td>
                              <td class="table-column-4">
                                <div class="icheck-material-deeporange icheck-inline">
                                  <input type="radio" name="category_thirdteen_sub_two_radio_one" id="checkbox-13-2r1_1"
                                    value="ไม่มี" v-model="evaluate.category_thirdteen_sub_two_radio_one
                                      " :disabled="evaluate.category_thirdteen_main_one ==
                                        'ไม่มี' ||
                                        evaluate.category_thirdteen_sub_two ==
                                        'ไม่มี'
                                        " />
                                  <label class="choice-1" for="checkbox-13-2r1_1">ไม่มี</label>
                                </div>
                                <div class="icheck-material-green icheck-inline ms-have">
                                  <input type="radio" name="category_thirdteen_sub_two_radio_one" id="checkbox-13-2r1_2"
                                    value="มี" v-model="evaluate.category_thirdteen_sub_two_radio_one
                                      " :disabled="evaluate.category_thirdteen_main_one ==
                                        'ไม่มี' ||
                                        evaluate.category_thirdteen_sub_two ==
                                        'ไม่มี'
                                        " />
                                  <label class="choice-2" for="checkbox-13-2r1_2">มี</label>
                                </div>
                              </td>
                              <td class="table-column-5"></td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    14.
                    โรงงานของท่านมีการประกอบกิจการเกี่ยวกับโรงไฟฟ้าพลังความร้อนหรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_fourteen_main_one" id="checkbox-14_1" value="ไม่มี"
                          onclick="evaluateChild('category-14','hide')" v-model="evaluate.category_fourteen_main_one" />
                        <label class="choice-1" for="checkbox-14_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_fourteen_main_one" id="checkbox-14_2" value="มี"
                          onclick="evaluateChild('category-14','show')" v-model="evaluate.category_fourteen_main_one" />
                        <label class="choice-2" for="checkbox-14_2">มี</label>
                      </div>
                    </div>

                    <div id="category-14" class="card-body card-body-subcategory" :class="{
                      'd-flex': evaluate.category_fourteen_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">
                                    ระบุชนิดของเชื้อเพลิง
                                  </div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_fourteen_sub_one_textbox_one"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_fourteen_sub_one_textbox_one
                                        " :disabled="evaluate.category_fourteen_main_one ==
                                          'ไม่มี'
                                          " :required="evaluate.category_fourteen_main_one !=
                                            'ไม่มี'
                                            " />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">
                                    ระบุชนิดของเชื้อเพลิง
                                  </div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_fourteen_sub_one_textbox_two"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_fourteen_sub_one_textbox_two
                                        " :disabled="evaluate.category_fourteen_main_one ==
                                          'ไม่มี'
                                          " />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">
                                    ระบุชนิดของเชื้อเพลิง
                                  </div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_fourteen_sub_one_textbox_three"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_fourteen_sub_one_textbox_three
                                        " :disabled="evaluate.category_fourteen_main_one ==
                                          'ไม่มี'
                                          " />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-2"></td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">
                                      คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_fourteen_sub_one_textbox_four"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_fourteen_sub_one_textbox_four
                                    " placeholder="" data-v-min="0" :disabled="evaluate.category_fourteen_main_one ==
                                      'ไม่มี'
                                      " :required="evaluate.category_fourteen_main_one !=
                                        'ไม่มี'
                                        " />
                              </td>
                              <td class="table-column-5">เมกะวัตต์</td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-2">
                                มีการใช้ถ่านหินเป็นเชื้อเพลิงหรือไม่
                              </td>
                              <td class="table-column-3"></td>
                              <td class="table-column-4">
                                <div class="icheck-material-deeporange icheck-inline">
                                  <input type="radio" name="category_fourteen_sub_one_radio_one" id="checkbox-14-1r1_1"
                                    value="ไม่มี" v-model="evaluate.category_fourteen_sub_one_radio_one
                                      " :disabled="evaluate.category_fourteen_main_one ==
                                        'ไม่มี'
                                        " />
                                  <label class="choice-1" for="checkbox-14-1r1_1">ไม่มี</label>
                                </div>
                                <div class="icheck-material-green icheck-inline ms-have">
                                  <input type="radio" name="category_fourteen_sub_one_radio_one" id="checkbox-14-1r1_2"
                                    value="มี" v-model="evaluate.category_fourteen_sub_one_radio_one
                                      " :disabled="evaluate.category_fourteen_main_one ==
                                        'ไม่มี'
                                        " />
                                  <label class="choice-2" for="checkbox-14-1r1_2">มี</label>
                                </div>
                              </td>
                              <td class="table-column-5"></td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    15.
                    โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการแยกหรือแปรสภาพก๊าซธรรมชาติ
                    หรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_fifteen_main_one" id="checkbox-15_1" value="ไม่มี"
                          v-model="evaluate.category_fifteen_main_one" />
                        <label class="choice-1" for="checkbox-15_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_fifteen_main_one" id="checkbox-15_2" value="มี"
                          v-model="evaluate.category_fifteen_main_one" />
                        <label class="choice-2" for="checkbox-15_2">มี</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    16.
                    โรงงานของท่านมีการประกอบกิจการเกี่ยวกับโรงงานปรับคุณภาพของเสียรวม
                    หรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_sixteen_main_one" id="checkbox-16_1" value="ไม่มี"
                          onclick="evaluateChild('category-16','hide')" v-model="evaluate.category_sixteen_main_one" />
                        <label class="choice-1" for="checkbox-16_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_sixteen_main_one" id="checkbox-16_2" value="มี"
                          onclick="evaluateChild('category-16','show')" v-model="evaluate.category_sixteen_main_one" />
                        <label class="choice-2" for="checkbox-16_2">มี</label>
                      </div>
                    </div>

                    <div id="category-16" class="card-body card-body-subcategory" :class="{
                      'd-flex': evaluate.category_sixteen_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td colspan="5" class="table-column-1">
                                <div class="icheck-material-blue icheck-inline">
                                  <input type="radio" name="category_sixteen_sub_one_radio_one" id="checkbox-16-1r1_1"
                                    value="ระบบบำบัดน้ำเสียรวม" v-model="evaluate.category_sixteen_sub_one_radio_one
                                      " :disabled="evaluate.category_sixteen_main_one ==
                                        'ไม่มี'
                                        " />
                                  <label class="choice-0" for="checkbox-16-1r1_1">ระบบบำบัดน้ำเสียรวม</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="5" class="table-column-1">
                                <div class="icheck-material-blue icheck-inline">
                                  <input type="radio" name="category_sixteen_sub_one_radio_one" id="checkbox-16-1r1_2"
                                    value="การเผาสิ่งปฏิกูลหรือวัสดุที่ไม่ใช้แล้วตามกฎหมายว่าด้วยโรงงาน" v-model="evaluate.category_sixteen_sub_one_radio_one
                                      " :disabled="evaluate.category_sixteen_main_one ==
                                        'ไม่มี'
                                        " />
                                  <label class="choice-0"
                                    for="checkbox-16-1r1_2">การเผาสิ่งปฏิกูลหรือวัสดุที่ไม่ใช้แล้วตามกฎหมายว่าด้วยโรงงาน</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="5" class="table-column-1">
                                <div class="icheck-material-blue icheck-inline">
                                  <input type="radio" name="category_sixteen_sub_one_radio_one" id="checkbox-16-1r1_3"
                                    value="การปรับสภาพสิ่งปฏิกูลหรือวัสดุที่ไม่ใช้แล้ว" v-model="evaluate.category_sixteen_sub_one_radio_one
                                      " :disabled="evaluate.category_sixteen_main_one ==
                                        'ไม่มี'
                                        " />
                                  <label class="choice-0"
                                    for="checkbox-16-1r1_3">การปรับสภาพสิ่งปฏิกูลหรือวัสดุที่ไม่ใช้แล้ว</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="icheck-material-lightblue icheck-inline">
                                  <input type="radio" name="category_sixteen_sub_one_radio_two" id="checkbox-16-1r2_1"
                                    value="อันตราย" v-model="evaluate.category_sixteen_sub_one_radio_two
                                      " :disabled="evaluate.category_sixteen_main_one ==
                                        'ไม่มี' ||
                                        evaluate.category_sixteen_sub_one_radio_one !=
                                        'การปรับสภาพสิ่งปฏิกูลหรือวัสดุที่ไม่ใช้แล้ว'
                                        " />
                                  <label class="choice-0" for="checkbox-16-1r2_1">อันตราย</label>
                                </div>
                                <div class="icheck-material-lightblue icheck-inline ms-have">
                                  <input type="radio" name="category_sixteen_sub_one_radio_two" id="checkbox-16-1r2_2"
                                    value="ไม่อันตราย" v-model="evaluate.category_sixteen_sub_one_radio_two
                                      " :disabled="evaluate.category_sixteen_main_one ==
                                        'ไม่มี' ||
                                        evaluate.category_sixteen_sub_one_radio_one !=
                                        'การปรับสภาพสิ่งปฏิกูลหรือวัสดุที่ไม่ใช้แล้ว'
                                        " />
                                  <label class="choice-0" for="checkbox-16-1r2_2">ไม่อันตราย</label>
                                </div>
                              </td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    17. โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการคัดแยกหรือ
                    ฝังกลบสิ่งปฏิกูลหรือวัสดุที่ไม่ใช้แล้ว หรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_seventeen_main_one" id="checkbox-17_1" value="ไม่มี"
                          onclick="evaluateChild('category-17','hide')"
                          v-model="evaluate.category_seventeen_main_one" />
                        <label class="choice-1" for="checkbox-17_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_seventeen_main_one" id="checkbox-17_2" value="มี"
                          onclick="evaluateChild('category-17','show')"
                          v-model="evaluate.category_seventeen_main_one" />
                        <label class="choice-2" for="checkbox-17_2">มี</label>
                      </div>
                    </div>

                    <div id="category-17" class="card-body card-body-subcategory" :class="{
                      'd-flex': evaluate.category_seventeen_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate">
                        <table class="table">
                          <tbody>
                            <tr>
                              <td colspan="5" class="table-column-1">
                                <div class="icheck-material-blue icheck-inline">
                                  <input type="radio" name="category_seventeen_sub_one" id="checkbox-17-1_1"
                                    value="การคัดแยกสิ่งปฏิกูลหรือวัสดุที่ไม่ใช้แล้ว" v-model="evaluate.category_seventeen_sub_one
                                      " :disabled="evaluate.category_seventeen_main_one ==
                                        'ไม่มี'
                                        " />
                                  <label class="choice-0"
                                    for="checkbox-17-1_1">การคัดแยกสิ่งปฏิกูลหรือวัสดุที่ไม่ใช้แล้ว</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="icheck-material-lightblue icheck-inline">
                                  <input type="radio" name="category_seventeen_sub_one_radio_one" id="checkbox-17-1r1_1"
                                    value="อันตราย" v-model="evaluate.category_seventeen_sub_one_radio_one
                                      " :disabled="evaluate.category_seventeen_main_one ==
                                        'ไม่มี' ||
                                        evaluate.category_seventeen_sub_one ==
                                        'การฝังกลบสิ่งปฏิกูลหรือวัสดุที่ไม่ใช้แล้ว'
                                        " />
                                  <label class="choice-0" for="checkbox-17-1r1_1">อันตราย</label>
                                </div>
                                <div class="icheck-material-lightblue icheck-inline ms-have">
                                  <input type="radio" name="category_seventeen_sub_one_radio_one" id="checkbox-17-1r1_2"
                                    value="ไม่อันตราย" v-model="evaluate.category_seventeen_sub_one_radio_one
                                      " :disabled="evaluate.category_seventeen_main_one ==
                                        'ไม่มี' ||
                                        evaluate.category_seventeen_sub_one ==
                                        'การฝังกลบสิ่งปฏิกูลหรือวัสดุที่ไม่ใช้แล้ว'
                                        " />
                                  <label class="choice-0" for="checkbox-17-1r1_2">ไม่อันตราย</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="5" class="table-column-1">
                                <div class="icheck-material-blue icheck-inline">
                                  <input type="radio" name="category_seventeen_sub_one" id="checkbox-17-1_2"
                                    value="การฝังกลบสิ่งปฏิกูลหรือวัสดุที่ไม่ใช้แล้ว" v-model="evaluate.category_seventeen_sub_one
                                      " :disabled="evaluate.category_seventeen_main_one ==
                                        'ไม่มี'
                                        " />
                                  <label class="choice-0"
                                    for="checkbox-17-1_2">การฝังกลบสิ่งปฏิกูลหรือวัสดุที่ไม่ใช้แล้ว</label>
                                </div>
                              </td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    18.
                    โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการนำผลิตภัณฑ์อุตสาหกรรมที่ไม่ใช้แล้วหรือของเสีย
                    ที่เป็นอันตรายจากโรงงานมาผลิตเป็นวัตถุดิบ
                    หรือผลิตภัณฑ์ใหม่โดยผ่านกรรมวิธีการผลิตทางอุตสาหกรรม หรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_eighteen_main_one" id="checkbox-18_1" value="ไม่มี"
                          onclick="evaluateChild('category-18','hide')" v-model="evaluate.category_eighteen_main_one" />
                        <label class="choice-1" for="checkbox-18_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_eighteen_main_one" id="checkbox-18_2" value="มี"
                          onclick="evaluateChild('category-18','show')" v-model="evaluate.category_eighteen_main_one" />
                        <label class="choice-2" for="checkbox-18_2">มี</label>
                      </div>
                    </div>

                    <div id="category-18" class="card-body card-body-subcategory" :class="{
                      'd-flex': evaluate.category_eighteen_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td colspan="5" class="table-column-1">
                                <div class="icheck-material-blue icheck-inline">
                                  <input type="radio" name="category_eighteen_sub_one_radio_one" id="checkbox-18-1r2_1"
                                    value="ไม่อันตราย" v-model="evaluate.category_eighteen_sub_one_radio_one
                                      " :disabled="evaluate.category_eighteen_main_one ==
                                        'ไม่มี'
                                        " />
                                  <label class="choice-0" for="checkbox-18-1r2_1">ไม่อันตราย</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="5" class="table-column-1">
                                <div class="icheck-material-blue icheck-inline">
                                  <input type="radio" name="category_eighteen_sub_one_radio_one" id="checkbox-18-1r2_2"
                                    value="อันตราย" v-model="evaluate.category_eighteen_sub_one_radio_one
                                      " :disabled="evaluate.category_eighteen_main_one ==
                                        'ไม่มี'
                                        " />
                                  <label class="choice-0" for="checkbox-18-1r2_2">อันตราย (เลือกได้มากกว่า 1)</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="icheck-material-indigo icheck-inline">
                                  <input type="checkbox" name="category_eighteen_sub_one_checkbox_one"
                                    id="checkbox-18-1c1"
                                    value="การนำผลิตภัณฑ์อุตสาหกรรมที่ไม่ใช้แล้ว มาผลิตเป็นวัตถุดิบหรือผลิตภัณฑ์ใหม่โดยผ่านกรรมวิธีการผลิตทางอุตสาหกรรม"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_eighteen_sub_one_checkbox_one
                                      " :disabled="evaluate.category_eighteen_main_one ==
                                        'ไม่มี' ||
                                        evaluate.category_eighteen_sub_one_radio_one ==
                                        'ไม่อันตราย'
                                        " />
                                  <label for="checkbox-18-1c1">การนำผลิตภัณฑ์อุตสาหกรรมที่ไม่ใช้แล้ว
                                    มาผลิตเป็นวัตถุดิบหรือผลิตภัณฑ์ใหม่โดยผ่านกรรมวิธีการผลิตทางอุตสาหกรรม</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="icheck-material-indigo icheck-inline">
                                  <input type="checkbox" name="category_eighteen_sub_one_checkbox_two"
                                    id="checkbox-18-1c2" value="การรีไซเคิลตะกั่วจากแบตเตอรี่เก่า" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_eighteen_sub_one_checkbox_two
                                      " :disabled="evaluate.category_eighteen_main_one ==
                                        'ไม่มี' ||
                                        evaluate.category_eighteen_sub_one_radio_one ==
                                        'ไม่อันตราย'
                                        " />
                                  <label for="checkbox-18-1c2">การรีไซเคิลตะกั่วจากแบตเตอรี่เก่า</label>
                                </div>
                              </td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-content-between mt-3">
                  <button type="button" id="step-2-back" class="btn btn-primary" @click="back()"
                    :disabled="evaluate.policy == 'ไม่ยอมรับ'">
                    กลับไปขั้นตอนก่อนหน้า
                    <i class="bi bi-arrow-left-square-fill ms-1"></i>
                  </button>
                  <button type="button" id="step-2-next" class="btn btn-primary"
                    @click="checkValidator('card-body-page-2', 'check_onsubmit_step_2_next')"
                    :disabled="evaluate.policy == 'ไม่ยอมรับ'">
                    ยืนยันและไปยังขั้นตอนต่อไป
                    <i class="bi bi-arrow-right-square-fill"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="card border-primary mb-3 border-evaluate" v-if="page == 3">
              <div class="card-header border-bottom-evaluate">
                <h4 class="text-primary mb-0 text-evaluate font-1_25">
                  ตรวจทานข้อมูลประกอบการประเมิน
                </h4>
              </div>
              <div class="card-body">
                <div class="card card-category">
                  <div class="card-header card-header-category">
                    1. การประกอบกิจการของท่าน มีน้ำเสียเกิดขึ้นหรือไม่
                  </div>
                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_one_main_one" id="checkbox-1_1" value="ไม่มี"
                          v-model="evaluate.category_one_main_one" disabled />
                        <label class="choice-1" for="checkbox-1_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_one_main_one" id="checkbox-1_2" value="มี"
                          v-model="evaluate.category_one_main_one" disabled />
                        <label class="choice-2" for="checkbox-1_2">มี</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    2. วิธีการจัดการน้ำเสียที่เกิดขึ้น
                  </div>

                  <div class="card-body card-body-category">
                    <div id="category-2" class="card-body card-body-subcategory" :class="{
                      'd-flex': evaluate.category_one_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_two_main_one" id="checkbox-2-1" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_two_main_one" disabled />
                                  <label for="checkbox-2-1"></label>
                                </div>
                              </td>
                              <td colspan="6" class="table-column-2">
                                2.1 มีระบบบำบัดน้ำเสียภายในโรงงาน
                                (เลือกได้มากกว่า 1 ข้อ)
                              </td>
                            </tr>

                            <!-- /. Start 2.1.1 -->
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_two_sub_one_one_checkbox" id="checkbox-2-1-1_1c"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_one_one_checkbox
                                      " disabled />
                                  <label for="checkbox-2-1-1_1c"></label>
                                </div>
                              </td>
                              <td colspan="5" class="table-column-2">
                                2.1.1 น้ำเสียปนเปื้อนสารอินทรีย์
                                (เลือกได้มากกว่า 1 ข้อ)
                              </td>
                            </tr>
                            <template v-for="(
itemSecondOneOne, itemIndex
                              ) in itemSecondOneOnes" :key="itemSecondOneOne.id">
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="4" class="table-column-2 system-header-category2">
                                  ระบบที่ {{ itemIndex + 1 }}
                                </td>
                                <td rowspan="4" class="table-column-8"></td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="2" class="table-column-2 bl-category2">
                                  แหล่งที่มาของน้ำเสีย
                                </td>
                                <td class="table-column-3">
                                  <div class="icheck-material-green icheck-inline">
                                    <input type="radio" name="category_two_sub_one_one_radio"
                                      :id="`checkbox-2-1-1r_1_${itemIndex + 1}`" value="น้ำเสียจากกระบวนการผลิต"
                                      v-model="itemSecondOneOne.category_two_sub_one_one_radio
                                        " disabled />
                                    <label class="choice-2" :for="`checkbox-2-1-1r_1_${itemIndex + 1
                                      }`">น้ำเสียจากกระบวนการผลิต</label>
                                  </div>
                                </td>
                                <td class="table-column-3 br-category2">
                                  <div class="icheck-material-green icheck-inline">
                                    <input type="radio" name="category_two_sub_one_one_radio"
                                      :id="`checkbox-2-1-1r_2_${itemIndex + 1}`" value="น้ำเสียจากการใช้น้ำของคนงาน"
                                      v-model="itemSecondOneOne.category_two_sub_one_one_radio
                                        " disabled />
                                    <label class="choice-2" :for="`checkbox-2-1-1r_2_${itemIndex + 1
                                      }`">น้ำเสียจากการใช้น้ำของคนงาน</label>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="2" class="table-column-2 bl-category2"></td>
                                <td class="table-column-3">
                                  <div class="icheck-material-green icheck-inline">
                                    <input type="radio" name="category_two_sub_one_one_radio"
                                      :id="`checkbox-2-1-1r_3_${itemIndex + 1}`" value="น้ำเสียจากน้ำหล่อเย็น" v-model="itemSecondOneOne.category_two_sub_one_one_radio
                                        " disabled />
                                    <label class="choice-2" :for="`checkbox-2-1-1r_3_${itemIndex + 1
                                      }`">น้ำเสียจากน้ำหล่อเย็น</label>
                                  </div>
                                </td>
                                <td class="table-column-3 br-category2">
                                  <div class="icheck-material-green icheck-inline">
                                    <input type="radio" name="category_two_sub_one_one_radio"
                                      :id="`checkbox-2-1-1r_4_${itemIndex + 1}`"
                                      value="น้ำเสียจากกิจกรรมอื่นๆ ในโรงงาน ระบุ" v-model="itemSecondOneOne.category_two_sub_one_one_radio
                                        " disabled />
                                    <label class="choice-2" :for="`checkbox-2-1-1r_4_${itemIndex + 1
                                      }`">น้ำเสียจากกิจกรรมอื่นๆ ในโรงงาน
                                      ระบุ</label>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="2" class="table-column-2 bl-category2">
                                  <div class="d-flex">
                                    <div class="d-flex">
                                      ชนิดของระบบบำบัดน้ำเสีย
                                    </div>
                                  </div>
                                </td>
                                <td colspan="2" class="table-column-3 br-category2">
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_two_sub_one_one_textbox_one"
                                      class="form-control form-control-evaluate ms-2" v-model="itemSecondOneOne.category_two_sub_one_one_textbox_one
                                        " disabled />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="2" class="table-column-2 bl-category2">
                                  ปริมาณน้ำเสียสูงสุดที่ระบบบำบัดน้ำเสียรองรับได้
                                  <sup>
                                    <div class="tooltip">
                                      <i class="bi bi-question-circle-fill"></i>
                                      <span class="tooltiptext">
                                        (คำอธิบาย :
                                        ต้องเป็นข้อมูลที่ได้จากค่าออกแบบระบบบำบัด
                                        น้ำเสีย)</span>
                                    </div>
                                  </sup>
                                </td>
                                <td class="table-column-3">
                                  <input type="text" name="category_two_sub_one_one_textbox_two"
                                    class="form-control form-control-evaluate text-end number" v-model="itemSecondOneOne.category_two_sub_one_one_textbox_two
                                      " placeholder="" data-v-min="0" disabled />
                                </td>
                                <td class="table-column-4 br-category2">
                                  ลูกบาศก์เมตร/วัน
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="2" class="table-column-2 bl-category2">
                                  ค่าบีโอดี(Biochemical Oxygen Demand)
                                  สูงสุดที่ระบบบำบัดน้ำเสียรองรับได้
                                </td>
                                <td class="table-column-3">
                                  <input type="text" name="category_two_sub_one_one_textbox_three"
                                    class="form-control form-control-evaluate text-end number" v-model="itemSecondOneOne.category_two_sub_one_one_textbox_three
                                      " placeholder="" data-v-min="0" disabled />
                                </td>
                                <td class="table-column-4 br-category2">
                                  มิลลิกรัม/ลิตร
                                </td>
                              </tr>
                              <tr class="tr-summary-margin-top">
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="2" class="summary table-column-2 bl-category2 bb-category2">
                                  ปริมาณความสกปรกในรูปบีโอดีก่อนเข้าระบบบำบัด
                                  (BOD Load of Influent) สูงสุด
                                </td>
                                <td class="summary table-column-4 text-end bb-category2">
                                  {{ itemSecondOneOnesBOD(itemSecondOneOne) }}
                                </td>
                                <td class="summary table-column-5 br-category2 bb-category2">
                                  กิโลกรัม/วัน
                                </td>
                              </tr>
                              <tr class="tr-summary-margin-bottom">
                                <td colspan="7"></td>
                              </tr>
                            </template>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2"></td>
                            </tr>
                            <tr class="tr-summary">
                              <td class="table-column-1"></td>
                              <td class="table-column-2"></td>
                              <td colspan="3" class="table-column-3">
                                <b>ปริมาณน้ำเสียสูงสุดรวม</b>
                              </td>
                              <td class="table-column-4 text-center">
                                <b>{{ evaluate.max_water_waste }}</b>
                              </td>
                              <td class="table-column-5">
                                <b>ลูกบาศก์เมตร/วัน</b>
                              </td>
                              <td class="table-column-5"></td>
                            </tr>
                            <tr class="tr-summary">
                              <td class="table-column-1"></td>
                              <td class="table-column-2"></td>
                              <td colspan="3" class="table-column-3">
                                <b>ปริมาณความสกปรกในรูปบีโอดีสูงสุดก่อนเข้าระบบบำบัด<br />(BOD
                                  Load of Influent)</b>
                              </td>
                              <td class="table-column-4 text-center">
                                <b>{{ evaluate.max_bod }}</b>
                              </td>
                              <td class="table-column-5">
                                <b>กิโลกรัม/วัน</b>
                              </td>
                              <td class="table-column-5"></td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                            <!-- /.End 2.1.1 -->

                            <!-- /. Start 2.1.2 -->
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_two_sub_one_two_checkbox" id="checkbox-2-1-2_1c"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_one_two_checkbox
                                      " disabled />
                                  <label for="checkbox-2-1-2_1c"></label>
                                </div>
                              </td>
                              <td colspan="5" class="table-column-2">
                                2.1.2 ระบบบำบัดน้ำเสียปนเปื้อนโลหะหนัก
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                น้ำเสียมีสารหรือองค์ประกอบของสาร
                                ดังต่อไปนี้(เลือกได้มากกว่า 1 ข้อ)
                              </td>
                            </tr>
                            <template v-for="(
itemSecondOneTwo, itemIndex2
                              ) in itemSecondOneTwos" :key="itemSecondOneTwo.id">
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="4" class="table-column-2 system-header-category2">
                                  ระบบที่ {{ itemIndex2 + 1 }}
                                </td>
                                <td rowspan="4" class="table-column-8"></td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-3 bl-category2">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_one"
                                      id="checkbox-2-1-2-1_c1" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_one
                                        " disabled />
                                    <label for="checkbox-2-1-2-1_c1">สังกะสี(Zinc)</label>
                                  </div>
                                </td>
                                <td class="table-column-3">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_two"
                                      id="checkbox-2-1-2-1_c2" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_two
                                        " disabled />
                                    <label for="checkbox-2-1-2-1_c2">แคดเมียม(Cadmium)</label>
                                  </div>
                                </td>
                                <td colspan="2" class="table-column-3 br-category2">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_three"
                                      id="checkbox-2-1-2-1_c3" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_three
                                        " disabled />
                                    <label for="checkbox-2-1-2-1_c3">ไซยาไนด์(Cyanide)</label>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="4" class="table-column-3 bl-category2 br-category2">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_four"
                                      id="checkbox-2-1-2-1_c4" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_four
                                        " disabled />
                                    <label for="checkbox-2-1-2-1_c4">ฟอสฟอรัสที่อยู่ในรูปของสารประกอบอินทรีย์(Organic
                                      Phosphorus Compounds)</label>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-3 bl-category2">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_five"
                                      id="checkbox-2-1-2-1_c5" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_five
                                        " disabled />
                                    <label for="checkbox-2-1-2-1_c5">ตะกั่ว(Lead)</label>
                                  </div>
                                </td>
                                <td class="table-column-3">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_six"
                                      id="checkbox-2-1-2-1_c6" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_six
                                        " disabled />
                                    <label for="checkbox-2-1-2-1_c6">ทองแดง(Copper)</label>
                                  </div>
                                </td>
                                <td colspan="2" class="table-column-3 br-category2">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_seven"
                                      id="checkbox-2-1-2-1_c7" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_seven
                                        " disabled />
                                    <label for="checkbox-2-1-2-1_c7">บาเรียม(Barium)</label>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-3 bl-category2">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_eight"
                                      id="checkbox-2-1-2-1_c8" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_eight
                                        " disabled />
                                    <label for="checkbox-2-1-2-1_c8">เซเลเนียม(Selenium)</label>
                                  </div>
                                </td>
                                <td class="table-column-3">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_nine"
                                      id="checkbox-2-1-2-1_c9" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_nine
                                        " disabled />
                                    <label for="checkbox-2-1-2-1_c9">นิเกิล(Nickel)</label>
                                  </div>
                                </td>
                                <td colspan="2" class="table-column-3 br-category2">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_ten"
                                      id="checkbox-2-1-2-1_c10" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_ten
                                        " disabled />
                                    <label for="checkbox-2-1-2-1_c10">แมงกานีส(Manganese)</label>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="4" class="table-column-3 bl-category2 br-category2">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_eleven"
                                      id="checkbox-2-1-2-1_c11" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_eleven
                                        " disabled />
                                    <label for="checkbox-2-1-2-1_c11">โครเมียม วาเลนซี 6(Hexavalent
                                      Chromium)</label>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="4" class="table-column-3 bl-category2 br-category2">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_twelve"
                                      id="checkbox-2-1-2-1_c12" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_twelve
                                        " disabled />
                                    <label for="checkbox-2-1-2-1_c12">อาร์ซินิคและสารประกอบอาร์ซินิค (Arsenic
                                      and its Compounds)</label>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="4" class="table-column-3 bl-category2 br-category2">
                                  <div class="icheck-material-indigo">
                                    <input type="checkbox" name="category_two_sub_two_one_checkbox_thirteen"
                                      id="checkbox-2-1-2-1_c13" true-value="มี" false-value="ไม่มี" v-model="itemSecondOneTwo.category_two_sub_two_one_checkbox_thirteen
                                        " disabled />
                                    <label for="checkbox-2-1-2-1_c13">ปรอทและสารประกอบปรอท(Mercury and its
                                      Compounds)</label>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="2" class="table-column-2 bl-category2">
                                  <div class="d-flex">
                                    <div class="d-flex">
                                      ชนิดของระบบบำบัดน้ำเสีย
                                    </div>
                                  </div>
                                </td>
                                <td colspan="2" class="table-column-3 br-category2">
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_two_sub_one_one_textbox_one"
                                      class="form-control form-control-evaluate ms-2" v-model="itemSecondOneTwo.category_two_sub_one_one_textbox_one
                                        " disabled />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td class="table-column-1"></td>
                                <td colspan="2" class="table-column-2 bl-category2 bb-category2 pb-2">
                                  ปริมาณน้ำเสียสูงสุดที่ระบบบำบัดน้ำเสียรองรับได้
                                  <sup>
                                    <div class="tooltip">
                                      <i class="bi bi-question-circle-fill"></i>
                                      <span class="tooltiptext">
                                        (คำอธิบาย :
                                        ต้องเป็นข้อมูลที่ได้จากค่าออกแบบระบบบำบัด
                                        น้ำเสีย)</span>
                                    </div>
                                  </sup>
                                </td>
                                <td class="table-column-3 bb-category2">
                                  <input type="text" name="category_two_sub_one_one_textbox_two"
                                    class="form-control form-control-evaluate text-end number" v-model="itemSecondOneTwo.category_two_sub_one_one_textbox_two
                                      " placeholder="" data-v-min="0" disabled />
                                </td>
                                <td class="table-column-4 br-category2 bb-category2">
                                  ลูกบาศก์เมตร/วัน
                                </td>
                              </tr>
                              <tr class="tr-summary-margin-bottom">
                                <td colspan="7"></td>
                              </tr>
                            </template>

                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2"></td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                            <!-- /.End 2.1.2 -->
                            <tr class="tr-summary">
                              <td class="table-column-1"></td>
                              <td class="table-column-2"></td>
                              <td colspan="3" class="table-column-3">
                                <b>ปริมาณน้ำเสียปนเปื้อนโลหะหนักสูงสุดรวม</b>
                              </td>
                              <td class="table-column-4 text-center">
                                <b>{{ itemSecondOneTwoMaxWaste(itemSecondOneTwos) }}</b>
                              </td>
                              <td class="table-column-5">
                                <b>ลูกบาศก์เมตร/วัน</b>
                              </td>
                              <td class="table-column-5"></td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_two_main_two_checkbox" id="checkbox-2-2"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_main_two_checkbox
                                      " disabled />
                                  <label for="checkbox-2-2"></label>
                                </div>
                              </td>
                              <td colspan="4" class="table-column-2">
                                2.2 มีการประกอบกิจการเกี่ยวกับการชุบโลหะ
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="6" class="table-column-2">
                                มีการใช้สารหรือองค์ประกอบของสาร ดังต่อไปนี้
                                (เลือกได้มากกว่า 1 ข้อ)
                              </td>
                            </tr>
                            <!-- Checkbox 2.2 -->
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_checkbox_one" id="checkbox-2-2_c1"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_one
                                      " disabled />
                                  <label for="checkbox-2-2_c1">สังกะสี(Zinc)</label>
                                </div>
                              </td>
                              <td class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_checkbox_two" id="checkbox-2-2_c2"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_two
                                      " disabled />
                                  <label for="checkbox-2-2_c2">แคดเมียม(Cadmium)</label>
                                </div>
                              </td>
                              <td colspan="2" class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_checkbox_three" id="checkbox-2-2_c3"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_three
                                      " disabled />
                                  <label for="checkbox-2-2_c3">ไซยาไนด์(Cyanide)</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_checkbox_four" id="checkbox-2-2_c4"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_four
                                      " disabled />
                                  <label for="checkbox-2-2_c4">ฟอสฟอรัสที่อยู่ในรูปของสารประกอบอินทรีย์(Organic
                                    Phosphorus Compounds)</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_checkbox_five" id="checkbox-2-2_c5"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_five
                                      " disabled />
                                  <label for="checkbox-2-2_c5">ตะกั่ว(Lead)</label>
                                </div>
                              </td>
                              <td class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_checkbox_six" id="checkbox-2-2_c6"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_six
                                      " disabled />
                                  <label for="checkbox-2-2_c6">ทองแดง(Copper)</label>
                                </div>
                              </td>
                              <td colspan="2" class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_checkbox_seven" id="checkbox-2-2_c7"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_seven
                                      " disabled />
                                  <label for="checkbox-2-2_c7">บาเรียม(Barium)</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_checkbox_eight" id="checkbox-2-2_c8"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_eight
                                      " disabled />
                                  <label for="checkbox-2-2_c8">เซเลเนียม(Selenium)</label>
                                </div>
                              </td>
                              <td class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_checkbox_nine" id="checkbox-2-2_c9"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_nine
                                      " disabled />
                                  <label for="checkbox-2-2_c9">นิเกิล(Nickel)</label>
                                </div>
                              </td>
                              <td colspan="2" class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_checkbox_ten" id="checkbox-2-2_c10"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_ten
                                      " disabled />
                                  <label for="checkbox-2-2_c10">แมงกานีส(Manganese)</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_one_checkbox_eleven"
                                    id="checkbox-2-2_c11" true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_eleven
                                      " disabled />
                                  <label for="checkbox-2-2_c11">โครเมียม วาเลนซี 6(Hexavalent
                                    Chromium)</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_checkbox_twelve"
                                    id="checkbox-2-2_c12" true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_twelve
                                      " disabled />
                                  <label for="checkbox-2-2_c12">อาร์ซินิคและสารประกอบอาร์ซินิค (Arsenic and
                                    its Compounds)</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-3">
                                <div class="icheck-material-indigo">
                                  <input type="checkbox" name="category_two_sub_two_checkbox_thirteen"
                                    id="checkbox-2-2_c13" true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_sub_two_checkbox_thirteen
                                      " disabled />
                                  <label for="checkbox-2-2_c13">ปรอทและสารประกอบปรอท(Mercury and its
                                    Compounds)</label>
                                </div>
                              </td>
                            </tr>
                            <!-- Checkbox 2.2 End-->
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_two_main_three_checkbox" id="checkbox-2-3"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_main_three_checkbox
                                      " disabled />
                                  <label for="checkbox-2-3"></label>
                                </div>
                              </td>
                              <td colspan="7" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">
                                    2.3 ส่งน้ำเสียไปบำบัดที่
                                  </div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_two_main_three_textbox_one"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_two_main_three_textbox_one
                                        " disabled />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_two_main_four_checkbox" id="checkbox-2-4"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_two_main_four_checkbox
                                      " disabled />
                                  <label for="checkbox-2-4"></label>
                                </div>
                              </td>
                              <td colspan="7" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">2.4 อื่นๆ</div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_two_main_four_textbox_one"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_two_main_four_textbox_one
                                        " disabled />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    3.
                    โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการผลิตน้ำตาลทรายดิบ
                    น้ำตาลทรายขาว น้ำตาลทรายขาวให้บริสุทธิ์ น้ำตาลกลูโคส
                    เดกซ์โทรส ฟรักโทส หรือผลิตภัณฑ์อื่นที่คล้ายคลึงกัน หรือไม่
                  </div>
                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_three_main_one" id="checkbox-3_1" value="ไม่มี"
                          v-model="evaluate.category_three_main_one" disabled />
                        <label class="choice-1" for="checkbox-3_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_three_main_one" id="checkbox-3_2" value="มี"
                          v-model="evaluate.category_three_main_one" disabled />
                        <label class="choice-2" for="checkbox-3_2">มี</label>
                      </div>
                    </div>

                    <div id="category-3" class="card-body card-body-subcategory" :class="{
                      'd-flex': evaluate.category_three_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_three_sub_one" id="checkbox-3-1" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_three_sub_one" disabled />
                                  <label for="checkbox-3-1"></label>
                                </div>
                              </td>
                              <td colspan="4" class="table-column-2">
                                การผลิตน้ำตาลทรายดิบ
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_three_sub_two" id="checkbox-3-2" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_three_sub_two" disabled />
                                  <label for="checkbox-3-2"></label>
                                </div>
                              </td>
                              <td colspan="4" class="table-column-2">
                                การผลิตน้ำตาลทรายขาว
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_three_sub_three" id="checkbox-3-3"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_three_sub_three"
                                    disabled />
                                  <label for="checkbox-3-3"></label>
                                </div>
                              </td>
                              <td colspan="4" class="table-column-2">
                                การผลิตน้ำตาลทรายขาวให้บริสุทธิ์
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_three_sub_four" id="checkbox-3-4"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_three_sub_four"
                                    disabled />
                                  <label for="checkbox-3-4"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                การผลิตน้ำตาลกลูโคส
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_three_sub_four_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_three_sub_four_textbox_one
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_three_sub_five" id="checkbox-3-5"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_three_sub_five"
                                    disabled />
                                  <label for="checkbox-3-5"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                การผลิตน้ำตาลเดกซ์โทรส
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">
                                      คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_three_sub_five_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_three_sub_five_textbox_one
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_three_sub_six" id="checkbox-3-6" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_three_sub_six" disabled />
                                  <label for="checkbox-3-6"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                การผลิตน้ำตาลฟรักโทส
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">
                                      คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_three_sub_six_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_three_sub_six_textbox_one
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_three_sub_seven" id="checkbox-3-7"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_three_sub_seven"
                                    disabled />
                                  <label for="checkbox-3-7"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                <div class="d-flex flex-column">
                                  <div>การผลิตผลิตภัณฑ์อื่นที่คล้ายคลึงกัน</div>
                                  <div class="d-flex">
                                    ระบุ
                                    <input type="text" name="category_three_sub_seven_one"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_three_sub_seven_one
                                        " disabled />
                                  </div>
                                </div>
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">
                                      คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_three_sub_seven_two"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_three_sub_seven_two
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    4. โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการผลิตสุรา
                    แอลกอฮอล์ ไวน์ เบียร์ หรือไม่
                  </div>
                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_four_main_one" id="checkbox-4_1" value="ไม่มี"
                          v-model="evaluate.category_four_main_one" disabled />
                        <label class="choice-1" for="checkbox-4_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_four_main_one" id="checkbox-4_2" value="มี"
                          v-model="evaluate.category_four_main_one" disabled />
                        <label class="choice-2" for="checkbox-4_2">มี</label>
                      </div>
                    </div>

                    <div id="category-4" class="card-body card-body-subcategory" :class="{
                      'd-flex': evaluate.category_four_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_four_sub_one" id="checkbox-4-1" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_four_sub_one" disabled />
                                  <label for="checkbox-4-1"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                การผลิตสุรา (คิดเทียบที่ 24 ดีกรี)
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_four_sub_one_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_four_sub_one_textbox_one
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">ลิตร/เดือน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_four_sub_two" id="checkbox-4-2" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_four_sub_two" disabled />
                                  <label for="checkbox-4-2"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                การผลิตแอลกอฮอล์ (คิดเทียบที่ 24 ดีกรี)
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_four_sub_two_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_four_sub_two_textbox_one
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">ลิตร/เดือน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_four_sub_three" id="checkbox-4-3"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_four_sub_three"
                                    disabled />
                                  <label for="checkbox-4-3"></label>
                                </div>
                              </td>
                              <td class="table-column-2">การผลิตไวน์</td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_four_sub_three_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_four_sub_three_textbox_one
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">ลิตร/เดือน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_four_sub_four" id="checkbox-4-4" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_four_sub_four" disabled />
                                  <label for="checkbox-4-4"></label>
                                </div>
                              </td>
                              <td class="table-column-2">การผลิตเบียร์</td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_four_sub_four_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_four_sub_four_textbox_one
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">ลิตร/เดือน</td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    5.
                    โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการผลิตเยื่อจากไม้หรือวัสดุอื่น
                    หรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_five_main_one" id="checkbox-5_1" value="ไม่มี"
                          v-model="evaluate.category_five_main_one" disabled />
                        <label class="choice-1" for="checkbox-5_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_five_main_one" id="checkbox-5_2" value="มี"
                          v-model="evaluate.category_five_main_one" disabled />
                        <label class="choice-2" for="checkbox-5_2">มี</label>
                      </div>
                    </div>

                    <div id="category-5" class="card-body card-body-subcategory" :class="{
                      'd-flex': evaluate.category_five_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_five_sub_one" id="checkbox-5-1" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_five_sub_one" disabled />
                                  <label for="checkbox-5-1"></label>
                                </div>
                              </td>
                              <td class="table-column-2">การผลิตเยื่อจากไม้</td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_five_sub_one_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_five_sub_one_textbox_one
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_five_sub_two" id="checkbox-5-2" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_five_sub_two" disabled />
                                  <label for="checkbox-5-2"></label>
                                </div>
                              </td>
                              <td colspan="4" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">
                                    การผลิตเยื่อจากวัสดุอื่น
                                  </div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_five_sub_two_textbox_one"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_five_sub_two_textbox_one
                                        " disabled />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">
                                    การผลิตเยื่อจากวัสดุอื่น
                                  </div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_five_sub_two_textbox_two"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_five_sub_two_textbox_two
                                        " disabled />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">
                                    การผลิตเยื่อจากวัสดุอื่น
                                  </div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_five_sub_two_textbox_three"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_five_sub_two_textbox_three
                                        " disabled />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-2"></td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">
                                      คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_five_sub_two_textbox_four"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_five_sub_two_textbox_four
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    6.
                    โรงงานของท่านมีการประกอบกิจการเกี่ยวกับปิโตรเคมีที่มีกระบวนการผลิตทางเคมี
                    หรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_six_main_one" id="checkbox-6_1" value="ไม่มี"
                          v-model="evaluate.category_six_main_one" disabled />
                        <label class="choice-1" for="checkbox-6_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_six_main_one" id="checkbox-6_2" value="มี"
                          v-model="evaluate.category_six_main_one" disabled />
                        <label class="choice-2" for="checkbox-6_2">มี</label>
                      </div>
                    </div>

                    <div id="category-6" class="card-body card-body-subcategory" :class="{
                      'd-flex': evaluate.category_six_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-2"></td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">
                                      คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_six_sub_one_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_six_sub_one_textbox_one
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    7. โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการผลิต
                    คลอ-แอลคาไลน์ที่ใช้โซเดียมคลอไรด์(NaCl)
                    เป็นวัตถุดิบในการผลิตโซเดียมคาร์บอเนต(Na<sub>2</sub>CO<sub>3</sub>)
                    โซเดียมไฮดรอกไซด์(NaOH) กรดไฮโดรคลอริก(HCl)
                    คลอรีน(Cl<sub>2</sub>) โซเดียมไฮโพคลอไรด์(NaOCl)
                    และปูนคลอรีน(Bleaching Powder) หรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_seven_main_one" id="checkbox-7_1" value="ไม่มี"
                          v-model="evaluate.category_seven_main_one" disabled />
                        <label class="choice-1" for="checkbox-7_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_seven_main_one" id="checkbox-7_2" value="มี"
                          v-model="evaluate.category_seven_main_one" disabled />
                        <label class="choice-2" for="checkbox-7_2">มี</label>
                      </div>
                    </div>

                    <div id="category-7" class="card-body card-body-subcategory" :class="{
                      'd-flex': evaluate.category_seven_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_seven_sub_one" id="checkbox-7-1" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_seven_sub_one" disabled />
                                  <label for="checkbox-7-1"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                โซเดียมคาร์บอเนต(Na<sub>2</sub>CO<sub>3</sub>)
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_seven_sub_one_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_seven_sub_one_textbox_one
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_seven_sub_two" id="checkbox-7-2" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_seven_sub_two" disabled />
                                  <label for="checkbox-7-2"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                โซเดียมไฮดรอกไซด์(NaOH)
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_seven_sub_two_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_seven_sub_two_textbox_one
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_seven_sub_three" id="checkbox-7-3"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_seven_sub_three"
                                    disabled />
                                  <label for="checkbox-7-3"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                กรดไฮโดรคลอริก(HCl)
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_seven_sub_three_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_seven_sub_three_textbox_one
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_seven_sub_four" id="checkbox-7-4"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_seven_sub_four"
                                    disabled />
                                  <label for="checkbox-7-4"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                คลอรีน(Cl<sub>2</sub>)
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_seven_sub_four_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_seven_sub_four_textbox_one
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_seven_sub_five" id="checkbox-7-5"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_seven_sub_five"
                                    disabled />
                                  <label for="checkbox-7-5"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                โซเดียมไฮโพคลอไรด์(NaOCl)
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_seven_sub_five_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_seven_sub_five_textbox_one
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_seven_sub_six" id="checkbox-7-6" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_seven_sub_six" disabled />
                                  <label for="checkbox-7-6"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                ปูนคลอรีน(Bleaching Powder)
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_seven_sub_six_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_seven_sub_six_textbox_one
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr class="tr-summary-margin-top">
                              <td colspan="5"></td>
                            </tr>
                            <tr class="tr-summary">
                              <td class="table-column-1"></td>
                              <td class="table-column-2"></td>
                              <td class="table-column-3">
                                <b>กำลังการผลิตรวม </b>
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4 text-center">
                                <b>{{ sumCategorySeven }}</b>
                              </td>
                              <td class="table-column-5"><b>ตัน/วัน</b></td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    8.
                    โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการผลิตสารออกฤทธิ์หรือสารที่ใช้ป้องกันหรือกำจัดศัตรูพืช
                    หรือสัตว์โดยใช้กระบวนการเคมีทุกขนาด
                    หรือประกอบกิจการเกี่ยวกับการผลิตปุ๋ยเคมี โดยใช้กระบวนการเคมี
                    หรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_eight_main_one" id="checkbox-8_1" value="ไม่มี"
                          v-model="evaluate.category_eight_main_one" disabled />
                        <label class="choice-1" for="checkbox-8_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_eight_main_one" id="checkbox-8_2" value="มี"
                          v-model="evaluate.category_eight_main_one" disabled />
                        <label class="choice-2" for="checkbox-8_2">มี</label>
                      </div>
                    </div>

                    <div id="category-8" class="card-body card-body-subcategory" :class="{
                      'd-flex': evaluate.category_eight_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_eight_sub_one" id="checkbox-8-1" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_eight_sub_one" disabled />
                                  <label for="checkbox-8-1"></label>
                                </div>
                              </td>
                              <td colspan="4" class="table-column-2">
                                การผลิตสารออกฤทธิ์หรือสารที่ใช้ป้องกันหรือกำจัดศัตรูพืชหรือสัตว์
                                โดยใช้กระบวนการเคมี
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_eight_sub_two" id="checkbox-8-2" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_eight_sub_two" disabled />
                                  <label for="checkbox-8-2"></label>
                                </div>
                              </td>
                              <td colspan="4" class="table-column-2">
                                การผลิตปุ๋ยเคมี
                              </td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    9. โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการผลิตยาง
                    เรซินสังเคราะห์ ยางอีลาสโตเมอร์ พลาสติก
                    หรือเส้นใยสังเคราะห์ซึ่งมิใช่ใยแก้ว หรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_nine_main_one" id="checkbox-9_1" value="ไม่มี"
                          v-model="evaluate.category_nine_main_one" disabled />
                        <label class="choice-1" for="checkbox-9_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_nine_main_one" id="checkbox-9_2" value="มี"
                          v-model="evaluate.category_nine_main_one" disabled />
                        <label class="choice-2" for="checkbox-9_2">มี</label>
                      </div>
                    </div>

                    <div id="category-9" class="card-body card-body-subcategory" :class="{
                      'd-flex': evaluate.category_nine_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_nine_sub_two" id="checkbox-9-1" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_nine_sub_two" disabled />
                                  <label for="checkbox-9-1"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                การผลิตเรซินสังเคราะห์
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_nine_sub_two_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_nine_sub_two_textbox_one
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_nine_sub_three" id="checkbox-9-2"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_nine_sub_three"
                                    disabled />
                                  <label for="checkbox-9-2"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                การผลิตยางอีลาสโตเมอร์
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_nine_sub_three_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_nine_sub_three_textbox_one
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_nine_sub_four" id="checkbox-9-3" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_nine_sub_four" disabled />
                                  <label for="checkbox-9-3"></label>
                                </div>
                              </td>
                              <td class="table-column-2">การผลิตพลาสติก</td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_nine_sub_four_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_nine_sub_four_textbox_one
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_nine_sub_five" id="checkbox-9-4" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_nine_sub_five" disabled />
                                  <label for="checkbox-9-4"></label>
                                </div>
                              </td>
                              <td class="table-column-2">
                                การผลิตเส้นใยสังเคราะห์ซึ่งมิใช่ใยแก้ว
                              </td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_nine_sub_five_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_nine_sub_five_textbox_one
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    10.
                    โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการกลั่นน้ำมันปิโตรเลียม
                    หรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_ten_main_one" id="checkbox-10_1" value="ไม่มี"
                          v-model="evaluate.category_ten_main_one" disabled />
                        <label class="choice-1" for="checkbox-10_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_ten_main_one" id="checkbox-10_2" value="มี"
                          v-model="evaluate.category_ten_main_one" disabled />
                        <label class="choice-2" for="checkbox-10_2">มี</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    11. โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการผลิตปูนซีเมนต์
                    หรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_eleven_main_one" id="checkbox-11_1" value="ไม่มี"
                          v-model="evaluate.category_eleven_main_one" disabled />
                        <label class="choice-1" for="checkbox-11_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_eleven_main_one" id="checkbox-11_2" value="มี"
                          v-model="evaluate.category_eleven_main_one" disabled />
                        <label class="choice-2" for="checkbox-11_2">มี</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    12.
                    โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการผลิตเหล็กหรือเหล็กกล้าหรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_twelveteen_main_one" id="checkbox-12_1" value="ไม่มี"
                          v-model="evaluate.category_twelveteen_main_one" disabled />
                        <label class="choice-1" for="checkbox-12_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_twelveteen_main_one" id="checkbox-12_2" value="มี"
                          v-model="evaluate.category_twelveteen_main_one" disabled />
                        <label class="choice-2" for="checkbox-12_2">มี</label>
                      </div>
                    </div>

                    <div id="category-12" class="card-body card-body-subcategory" :class="{
                      'd-flex':
                        evaluate.category_twelveteen_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_twelveteen_sub_one" id="checkbox-12-1"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_twelveteen_sub_one
                                      " disabled />
                                  <label for="checkbox-12-1"></label>
                                </div>
                              </td>
                              <td class="table-column-2">การผลิตเหล็ก</td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_twelveteen_sub_one_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_twelveteen_sub_one_textbox_one
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-2">
                                มีน้ำเสียเกิดขึ้นหรือไม่
                              </td>
                              <td class="table-column-3"></td>
                              <td class="table-column-4">
                                <div class="icheck-material-deeporange icheck-inline">
                                  <input type="radio" name="category_twelveteen_sub_one_radio_one"
                                    id="checkbox-12-1r1_1" value="ไม่มี" v-model="evaluate.category_twelveteen_sub_one_radio_one
                                      " disabled />
                                  <label class="choice-1" for="checkbox-12-1r1_1">ไม่มี</label>
                                </div>
                                <div class="icheck-material-green icheck-inline ms-have">
                                  <input type="radio" name="category_twelveteen_sub_one_radio_one"
                                    id="checkbox-12-1r1_2" value="มี" v-model="evaluate.category_twelveteen_sub_one_radio_one
                                      " disabled />
                                  <label class="choice-2" for="checkbox-12-1r1_2">มี</label>
                                </div>
                              </td>
                              <td class="table-column-5"></td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_twelveteen_sub_two" id="checkbox-12-2"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_twelveteen_sub_two
                                      " disabled />
                                  <label for="checkbox-12-2"></label>
                                </div>
                              </td>
                              <td class="table-column-2">การผลิตเหล็กกล้า</td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_twelveteen_sub_two_textbox_one"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_twelveteen_sub_two_textbox_one
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-2">
                                มีน้ำเสียเกิดขึ้นหรือไม่
                              </td>
                              <td class="table-column-3"></td>
                              <td class="table-column-4">
                                <div class="icheck-material-deeporange icheck-inline">
                                  <input type="radio" name="category_twelveteen_sub_two_radio_one"
                                    id="checkbox-12-2r1_1" value="ไม่มี" v-model="evaluate.category_twelveteen_sub_two_radio_one
                                      " disabled />
                                  <label class="choice-1" for="checkbox-12-2r1_1">ไม่มี</label>
                                </div>
                                <div class="icheck-material-green icheck-inline ms-have">
                                  <input type="radio" name="category_twelveteen_sub_two_radio_one"
                                    id="checkbox-12-2r1_2" value="มี" v-model="evaluate.category_twelveteen_sub_two_radio_one
                                      " disabled />
                                  <label class="choice-2" for="checkbox-12-2r1_2">มี</label>
                                </div>
                              </td>
                              <td class="table-column-5"></td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    13. โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการถลุง
                    หรือหลอมโลหะ ซึ่งไม่ใช่อุตสาหกรรมเหล็ก หรือเหล็กกล้า หรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_thirdteen_main_one" id="checkbox-13_1" value="ไม่มี"
                          v-model="evaluate.category_thirdteen_main_one" disabled />
                        <label class="choice-1" for="checkbox-13_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_thirdteen_main_one" id="checkbox-13_2" value="มี"
                          v-model="evaluate.category_thirdteen_main_one" disabled />
                        <label class="choice-2" for="checkbox-13_2">มี</label>
                      </div>
                    </div>

                    <div id="category-13" class="card-body card-body-subcategory"
                      v-show="evaluate.category_thirdteen_main_one != 'ไม่มี'">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_thirdteen_sub_one" id="checkbox-13-1"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_thirdteen_sub_one
                                      " disabled />
                                  <label for="checkbox-13-1"></label>
                                </div>
                              </td>
                              <td colspan="4" class="table-column-2">
                                การถลุงโลหะ
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">ระบุชนิดของโลหะ</div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_thirdteen_sub_one_textbox_one"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_thirdteen_sub_one_textbox_one
                                        " disabled />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">ระบุชนิดของโลหะ</div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_thirdteen_sub_one_textbox_two"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_thirdteen_sub_one_textbox_two
                                        " disabled />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">ระบุชนิดของโลหะ</div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_thirdteen_sub_one_textbox_three"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_thirdteen_sub_one_textbox_three
                                        " disabled />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-2"></td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">
                                      คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_thirdteen_sub_one_textbox_four"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_thirdteen_sub_one_textbox_four
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-2">
                                มีน้ำเสียเกิดขึ้นหรือไม่
                              </td>
                              <td class="table-column-3"></td>
                              <td class="table-column-4">
                                <div class="icheck-material-deeporange icheck-inline">
                                  <input type="radio" name="category_thirdteen_sub_one_radio_one" id="checkbox-13-1r1_1"
                                    value="ไม่มี" v-model="evaluate.category_thirdteen_sub_one_radio_one
                                      " disabled />
                                  <label class="choice-1" for="checkbox-13-1r1_1">ไม่มี</label>
                                </div>
                                <div class="icheck-material-green icheck-inline ms-have">
                                  <input type="radio" name="category_thirdteen_sub_one_radio_one" id="checkbox-13-1r1_2"
                                    value="มี" v-model="evaluate.category_thirdteen_sub_one_radio_one
                                      " disabled />
                                  <label class="choice-2" for="checkbox-13-1r1_2">มี</label>
                                </div>
                              </td>
                              <td class="table-column-5"></td>
                            </tr>
                            <tr>
                              <td class="table-column-1">
                                <div class="icheck-material-teal">
                                  <input type="checkbox" name="category_thirdteen_sub_two" id="checkbox-13-2"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_thirdteen_sub_two
                                      " disabled />
                                  <label for="checkbox-13-2"></label>
                                </div>
                              </td>
                              <td colspan="4" class="table-column-2">
                                การหลอมโลหะ
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">ระบุชนิดของโลหะ</div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_thirdteen_sub_two_textbox_one"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_thirdteen_sub_two_textbox_one
                                        " disabled />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">ระบุชนิดของโลหะ</div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_thirdteen_sub_two_textbox_two"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_thirdteen_sub_two_textbox_two
                                        " disabled />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">ระบุชนิดของโลหะ</div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_thirdteen_sub_two_textbox_three"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_thirdteen_sub_two_textbox_three
                                        " disabled />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-2"></td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">
                                      คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_thirdteen_sub_two_textbox_four"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_thirdteen_sub_two_textbox_four
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">ตัน/วัน</td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-2">
                                มีน้ำเสียเกิดขึ้นหรือไม่
                              </td>
                              <td class="table-column-3"></td>
                              <td class="table-column-4">
                                <div class="icheck-material-deeporange icheck-inline">
                                  <input type="radio" name="category_thirdteen_sub_two_radio_one" id="checkbox-13-2r1_1"
                                    value="ไม่มี" v-model="evaluate.category_thirdteen_sub_two_radio_one
                                      " disabled />
                                  <label class="choice-1" for="checkbox-13-2r1_1">ไม่มี</label>
                                </div>
                                <div class="icheck-material-green icheck-inline ms-have">
                                  <input type="radio" name="category_thirdteen_sub_two_radio_one" id="checkbox-13-2r1_2"
                                    value="มี" v-model="evaluate.category_thirdteen_sub_two_radio_one
                                      " disabled />
                                  <label class="choice-2" for="checkbox-13-2r1_2">มี</label>
                                </div>
                              </td>
                              <td class="table-column-5"></td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    14.
                    โรงงานของท่านมีการประกอบกิจการเกี่ยวกับโรงไฟฟ้าพลังความร้อนหรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_fourteen_main_one" id="checkbox-14_1" value="ไม่มี"
                          v-model="evaluate.category_fourteen_main_one" disabled />
                        <label class="choice-1" for="checkbox-14_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_fourteen_main_one" id="checkbox-14_2" value="มี"
                          v-model="evaluate.category_fourteen_main_one" disabled />
                        <label class="choice-2" for="checkbox-14_2">มี</label>
                      </div>
                    </div>

                    <div id="category-14" class="card-body card-body-subcategory" :class="{
                      'd-flex':
                        evaluate.category_fourteen_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">
                                    ระบุชนิดของเชื้อเพลิง
                                  </div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_fourteen_sub_one_textbox_one"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_fourteen_sub_one_textbox_one
                                        " disabled />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">
                                    ระบุชนิดของเชื้อเพลิง
                                  </div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_fourteen_sub_one_textbox_two"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_fourteen_sub_one_textbox_two
                                        " disabled />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="d-flex">
                                  <div class="d-flex">
                                    ระบุชนิดของเชื้อเพลิง
                                  </div>
                                  <div class="d-flex ms-3 flex-fill">
                                    ระบุ
                                    <input type="text" name="category_fourteen_sub_one_textbox_three"
                                      class="form-control form-control-evaluate ms-2" v-model="evaluate.category_fourteen_sub_one_textbox_three
                                        " disabled />
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-2"></td>
                              <td class="table-column-3">
                                กำลังการผลิตสูงสุด
                                <sup>
                                  <div class="tooltip">
                                    <i class="bi bi-question-circle-fill"></i>
                                    <span class="tooltiptext">
                                      คำอธิบาย : ข้อมูลกำลังการผลิตสูงสุด
                                      ต้องเป็นข้อมูลที่ได้จาก<br />
                                      &nbsp;&nbsp;1)
                                      กำลังการผลิตสูงสุดที่ได้รับอนุญาต<br />
                                      &nbsp;&nbsp;2) หากไม่มีข้อมูลในข้อ 1)
                                      ให้ใช้ข้อมูลสถิติกำลังการผลิตสูงสุดของโรงงาน
                                      ในรอบ 6 เดือน</span>
                                  </div>
                                </sup>
                              </td>
                              <td class="table-column-4">
                                <input type="text" name="category_fourteen_sub_one_textbox_four"
                                  class="form-control form-control-evaluate text-end number" v-model="evaluate.category_fourteen_sub_one_textbox_four
                                    " placeholder="" data-v-min="0" disabled />
                              </td>
                              <td class="table-column-5">เมกะวัตต์</td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td class="table-column-2">
                                มีการใช้ถ่านหินเป็นเชื้อเพลิงหรือไม่
                              </td>
                              <td class="table-column-3"></td>
                              <td class="table-column-4">
                                <div class="icheck-material-deeporange icheck-inline">
                                  <input type="radio" name="category_fourteen_sub_one_radio_one" id="checkbox-14-1r1_1"
                                    value="ไม่มี" v-model="evaluate.category_fourteen_sub_one_radio_one
                                      " disabled />
                                  <label class="choice-1" for="checkbox-14-1r1_1">ไม่มี</label>
                                </div>
                                <div class="icheck-material-green icheck-inline ms-have">
                                  <input type="radio" name="category_fourteen_sub_one_radio_one" id="checkbox-14-1r1_2"
                                    value="มี" v-model="evaluate.category_fourteen_sub_one_radio_one
                                      " disabled />
                                  <label class="choice-2" for="checkbox-14-1r1_2">มี</label>
                                </div>
                              </td>
                              <td class="table-column-5"></td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    15.
                    โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการแยกหรือแปรสภาพก๊าซธรรมชาติ
                    หรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_fifteen_main_one" id="checkbox-15_1" value="ไม่มี"
                          v-model="evaluate.category_fifteen_main_one" disabled />
                        <label class="choice-1" for="checkbox-15_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_fifteen_main_one" id="checkbox-15_2" value="มี"
                          v-model="evaluate.category_fifteen_main_one" disabled />
                        <label class="choice-2" for="checkbox-15_2">มี</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    16.
                    โรงงานของท่านมีการประกอบกิจการเกี่ยวกับโรงงานปรับคุณภาพของเสียรวม
                    หรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_sixteen_main_one" id="checkbox-16_1" value="ไม่มี"
                          v-model="evaluate.category_sixteen_main_one" disabled />
                        <label class="choice-1" for="checkbox-16_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_sixteen_main_one" id="checkbox-16_2" value="มี"
                          v-model="evaluate.category_sixteen_main_one" disabled />
                        <label class="choice-2" for="checkbox-16_2">มี</label>
                      </div>
                    </div>
                    <div id="category-16" class="card-body card-body-subcategory" :class="{
                      'd-flex': evaluate.category_sixteen_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td colspan="5" class="table-column-1">
                                <div class="icheck-material-blue icheck-inline">
                                  <input type="radio" name="category_sixteen_sub_one_radio_one" id="checkbox-16-1r1_1"
                                    value="ระบบบำบัดน้ำเสียรวม" v-model="evaluate.category_sixteen_sub_one_radio_one
                                      " disabled />
                                  <label class="choice-0" for="checkbox-16-1r1_1">ระบบบำบัดน้ำเสียรวม</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="5" class="table-column-1">
                                <div class="icheck-material-blue icheck-inline">
                                  <input type="radio" name="category_sixteen_sub_one_radio_one" id="checkbox-16-1r1_2"
                                    value="การเผาสิ่งปฏิกูลหรือวัสดุที่ไม่ใช้แล้วตามกฎหมายว่าด้วยโรงงาน" v-model="evaluate.category_sixteen_sub_one_radio_one
                                      " disabled />
                                  <label class="choice-0"
                                    for="checkbox-16-1r1_2">การเผาสิ่งปฏิกูลหรือวัสดุที่ไม่ใช้แล้วตามกฎหมายว่าด้วยโรงงาน</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="5" class="table-column-1">
                                <div class="icheck-material-blue icheck-inline">
                                  <input type="radio" name="category_sixteen_sub_one_radio_one" id="checkbox-16-1r1_3"
                                    value="การปรับสภาพสิ่งปฏิกูลหรือวัสดุที่ไม่ใช้แล้ว" v-model="evaluate.category_sixteen_sub_one_radio_one
                                      " disabled />
                                  <label class="choice-0"
                                    for="checkbox-16-1r1_3">การปรับสภาพสิ่งปฏิกูลหรือวัสดุที่ไม่ใช้แล้ว</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="icheck-material-lightblue icheck-inline">
                                  <input type="radio" name="category_sixteen_sub_one_radio_two" id="checkbox-16-1r2_1"
                                    value="อันตราย" v-model="evaluate.category_sixteen_sub_one_radio_two
                                      " disabled />
                                  <label class="choice-0" for="checkbox-16-1r2_1">อันตราย</label>
                                </div>
                                <div class="icheck-material-lightblue icheck-inline ms-have">
                                  <input type="radio" name="category_sixteen_sub_one_radio_two" id="checkbox-16-1r2_2"
                                    value="ไม่อันตราย" v-model="evaluate.category_sixteen_sub_one_radio_two
                                      " disabled />
                                  <label class="choice-0" for="checkbox-16-1r2_2">ไม่อันตราย</label>
                                </div>
                              </td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    17. โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการคัดแยกหรือ
                    ฝังกลบสิ่งปฏิกูลหรือวัสดุที่ไม่ใช้แล้ว หรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_seventeen_main_one" id="checkbox-17_1" value="ไม่มี"
                          v-model="evaluate.category_seventeen_main_one" disabled />
                        <label class="choice-1" for="checkbox-17_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_seventeen_main_one" id="checkbox-17_2" value="มี"
                          v-model="evaluate.category_seventeen_main_one" disabled />
                        <label class="choice-2" for="checkbox-17_2">มี</label>
                      </div>
                    </div>
                    <div id="category-17" class="card-body card-body-subcategory" :class="{
                      'd-flex':
                        evaluate.category_seventeen_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate">
                        <table class="table">
                          <tbody>
                            <tr>
                              <td colspan="5" class="table-column-1">
                                <div class="icheck-material-blue icheck-inline">
                                  <input type="radio" name="category_seventeen_sub_one" id="checkbox-17-1_1"
                                    value="การคัดแยกสิ่งปฏิกูลหรือวัสดุที่ไม่ใช้แล้ว" v-model="evaluate.category_seventeen_sub_one
                                      " disabled />
                                  <label class="choice-0"
                                    for="checkbox-17-1_1">การคัดแยกสิ่งปฏิกูลหรือวัสดุที่ไม่ใช้แล้ว</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="icheck-material-lightblue icheck-inline">
                                  <input type="radio" name="category_seventeen_sub_one_radio_one" id="checkbox-17-1r1_1"
                                    value="อันตราย" v-model="evaluate.category_seventeen_sub_one_radio_one
                                      " disabled />
                                  <label class="choice-0" for="checkbox-17-1r1_1">อันตราย</label>
                                </div>
                                <div class="icheck-material-lightblue icheck-inline ms-have">
                                  <input type="radio" name="category_seventeen_sub_one_radio_one" id="checkbox-17-1r1_2"
                                    value="ไม่อันตราย" v-model="evaluate.category_seventeen_sub_one_radio_one
                                      " disabled />
                                  <label class="choice-0" for="checkbox-17-1r1_2">ไม่อันตราย</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="5" class="table-column-1">
                                <div class="icheck-material-blue icheck-inline">
                                  <input type="radio" name="category_seventeen_sub_one" id="checkbox-17-1_2"
                                    value="การฝังกลบสิ่งปฏิกูลหรือวัสดุที่ไม่ใช้แล้ว" v-model="evaluate.category_seventeen_sub_one
                                      " disabled />
                                  <label class="choice-0"
                                    for="checkbox-17-1_2">การฝังกลบสิ่งปฏิกูลหรือวัสดุที่ไม่ใช้แล้ว</label>
                                </div>
                              </td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card card-category">
                  <div class="card-header card-header-category">
                    18.
                    โรงงานของท่านมีการประกอบกิจการเกี่ยวกับการนำผลิตภัณฑ์อุตสาหกรรมที่ไม่ใช้แล้วหรือของเสีย
                    ที่เป็นอันตรายจากโรงงานมาผลิตเป็นวัตถุดิบ
                    หรือผลิตภัณฑ์ใหม่โดยผ่านกรรมวิธีการผลิตทางอุตสาหกรรม หรือไม่
                  </div>

                  <div class="card-body card-body-category">
                    <div class="choice-body">
                      <div class="icheck-material-red icheck-inline">
                        <input type="radio" name="category_eighteen_main_one" id="checkbox-18_1" value="ไม่มี"
                          v-model="evaluate.category_eighteen_main_one" disabled />
                        <label class="choice-1" for="checkbox-18_1">ไม่มี</label>
                      </div>
                      <div class="icheck-material-teal icheck-inline ms-have">
                        <input type="radio" name="category_eighteen_main_one" id="checkbox-18_2" value="มี"
                          v-model="evaluate.category_eighteen_main_one" disabled />
                        <label class="choice-2" for="checkbox-18_2">มี</label>
                      </div>
                    </div>
                    <div id="category-18" class="card-body card-body-subcategory" :class="{
                      'd-flex':
                        evaluate.category_eighteen_main_one != 'ไม่มี',
                    }">
                      <div class="table-evaluate" data-checkbox-group data-v-min-select='1' data-v-required>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td colspan="5" class="table-column-1">
                                <div class="icheck-material-blue icheck-inline">
                                  <input type="radio" name="category_eighteen_sub_one_radio_one" id="checkbox-18-1r2_1"
                                    value="ไม่อันตราย" v-model="evaluate.category_eighteen_sub_one_radio_one
                                      " disabled />
                                  <label class="choice-0" for="checkbox-18-1r2_1">ไม่อันตราย</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="5" class="table-column-1">
                                <div class="icheck-material-blue icheck-inline">
                                  <input type="radio" name="category_eighteen_sub_one_radio_one" id="checkbox-18-1r2_2"
                                    value="อันตราย" v-model="evaluate.category_eighteen_sub_one_radio_one
                                      " disabled />
                                  <label class="choice-0" for="checkbox-18-1r2_2">อันตราย (เลือกได้มากกว่า 1)</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="icheck-material-indigo icheck-inline">
                                  <input type="checkbox" name="category_eighteen_sub_one_checkbox_one"
                                    id="checkbox-18-1c1"
                                    value="การนำผลิตภัณฑ์อุตสาหกรรมที่ไม่ใช้แล้ว มาผลิตเป็นวัตถุดิบหรือผลิตภัณฑ์ใหม่โดยผ่านกรรมวิธีการผลิตทางอุตสาหกรรม"
                                    true-value="มี" false-value="ไม่มี" v-model="evaluate.category_eighteen_sub_one_checkbox_one
                                      " disabled />
                                  <label for="checkbox-18-1c1">การนำผลิตภัณฑ์อุตสาหกรรมที่ไม่ใช้แล้ว
                                    มาผลิตเป็นวัตถุดิบหรือผลิตภัณฑ์ใหม่โดยผ่านกรรมวิธีการผลิตทางอุตสาหกรรม</label>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="table-column-1"></td>
                              <td colspan="4" class="table-column-2">
                                <div class="icheck-material-indigo icheck-inline">
                                  <input type="checkbox" name="category_eighteen_sub_one_checkbox_two"
                                    id="checkbox-18-1c2" value="การรีไซเคิลตะกั่วจากแบตเตอรี่เก่า" true-value="มี"
                                    false-value="ไม่มี" v-model="evaluate.category_eighteen_sub_one_checkbox_two
                                      " disabled />
                                  <label for="checkbox-18-1c2">การรีไซเคิลตะกั่วจากแบตเตอรี่เก่า</label>
                                </div>
                              </td>
                            </tr>
                            <tr class="tr-summary-margin-bottom">
                              <td colspan="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-content-between mt-3">
                  <button type="button" id="step-1-next" class="btn btn-primary" @click="back()"
                    :disabled="evaluate.policy == 'ไม่ยอมรับ'">
                    กลับไปขั้นตอนก่อนหน้า
                    <i class="bi bi-arrow-left-square-fill ms-1"></i>
                  </button>
                  <button type="button" id="step-1-next" class="btn btn-primary" @click="next()"
                    :disabled="evaluate.policy == 'ไม่ยอมรับ'">
                    ยืนยันและไปยังขั้นตอนต่อไป
                    <i class="bi bi-arrow-right-square-fill"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="card border-primary mb-3 border-evaluate" v-if="page == 4">
              <div class="card-header border-bottom-evaluate">
                <h4 class="text-primary mb-0 text-evaluate font-1_25">
                  ตรวจทานข้อมูลผู้ต้องการประเมิน
                </h4>
              </div>
              <div class="card-body">
                <div class="row form-group mb-3">
                  <label class="col-sm-2 col-form-label text-sm-end text-start default-text">ขื่อผู้รับใบอนุญาตฯ</label>
                  <div class="col-sm-4">
                    <input type="text" class="form-control" name="factory_name" v-model="evaluate.factory_name"
                      disabled />
                  </div>
                  <label class="col-sm-2 col-form-label text-sm-end text-start default-text">เลขทะเบียนโรงงาน
                    (ใหม่)</label>
                  <div class="col-sm-4">
                    <input type="text" class="form-control" name="idcard" v-model="evaluate.fid" disabled />
                  </div>
                </div>
                <div class="row form-group mb-3">
                  <label class="col-sm-2 col-form-label text-sm-end text-start default-text">เลขทะเบียนโรงงาน
                    (เก่า)</label>
                  <div class="col-sm-4">
                    <input type="text" class="form-control" name="dispfacreg" v-model="evaluate.dispfacreg" disabled />
                  </div>
                  <label class="col-sm-2 col-form-label text-sm-end text-start default-text">เลขประจำตัวผู้เสียภาษี 13
                    หลัก
                  </label>
                  <div class="col-sm-4">
                    <input type="text" class="form-control" name="tax_id" v-model="evaluate.tax_id" disabled />
                  </div>
                </div>
                <div class="row form-group mb-3">
                  <label class="col-sm-2 col-form-label text-sm-end text-start default-text">ชื่อ-นามสกุล
                    (ผู้ประสานงาน)</label>
                  <div class="col-sm-4">
                    <input type="text" class="form-control" name="contact_name" v-model="evaluate.contact_name"
                      disabled />
                  </div>
                  <label class="col-sm-2 col-form-label text-sm-end text-start default-text">e-mail</label>
                  <div class="col-sm-4">
                    <input type="text" class="form-control" name="email" v-model="evaluate.email" disabled />
                  </div>
                </div>
                <div class="row form-group mb-3">
                  <label
                    class="col-sm-2 col-form-label text-sm-end text-start default-text">เบอร์โทรศัพท์ผู้ประสานงาน</label>
                  <div class="col-sm-4">
                    <input type="text" class="form-control" name="telephone" v-model="evaluate.telephone" disabled />
                  </div>
                </div>
                <div class="row form-group mb-3">
                  <div class="col-md-12">
                    <div class="input-group captcha">
                      <div class="col-form-label input-group-text" style="padding: 0 0.75rem !important"
                        v-html="captcha"></div>
                      <input id="captcha" type="text" class="form-control" placeholder="Enter Captcha" name="captcha"
                        v-model="evaluate.captcha" />
                      <button type="button" class="input-group-text" style="
                          background-color: #e9ecef;
                          border: 1px solid #ced4da;
                        ">
                        <i id="refresh" class="refresh" @click.prevent="refreshCaptcha()">&#x21bb;</i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-between mt-3">
                  <button type="button" id="step-1-back" class="btn btn-primary" @click="back()"
                    :disabled="evaluate.policy == 'ไม่ยอมรับ'">
                    กลับไปขั้นตอนก่อนหน้า
                    <i class="bi bi-arrow-left-square-fill ms-1"></i>
                  </button>
                  <button type="button" id="step-1-next" class="btn btn-primary" @click="save()"
                    :disabled="evaluate.policy == 'ไม่ยอมรับ'">
                    จัดส่งข้อมูล
                    <i class="bi bi-arrow-right-square-fill ms-1"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="card border-primary mb-3 border-evaluate" v-if="page == 5">
              <div class="card-header border-bottom-evaluate">
                <h4 class="text-primary mb-0 text-evaluate font-1_25">
                  ยืนยันผล
                </h4>
              </div>
              <div class="card-body">
                <div class="d-flex justify-content-center align-items-center flex-column">
                  <div style="font-size: 1.5rem; margin-bottom: 2rem">
                    เรียนผู้ต้องการประเมิน
                  </div>
                  <div style="font-size: 1.25rem">
                    <div style="
                        font-size: 1.15rem;
                        color: #059669;
                        text-align: center;
                      ">
                      <i class="bi bi-clipboard-check-fill"></i> {{ topic }}
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-center mt-3">
                  <button type="button" id="step-1-back" class="btn btn-primary" @click="close()">
                    ปิดหน้าต่าง<i class="bi bi-arrow-left-square-fill ms-1"></i>
                  </button>
                </div>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { v4 as uuidv4 } from "uuid";
import Swal from "sweetalert2";
import { debounce } from "lodash";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import VuePdfEmbed from "vue-pdf-embed";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { _formatDatetime, _convertTimezone } from "@/helpers/datetime-helper";
import { max } from "lodash";

// TP Add
import "icheck-material/icheck-material.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

export default {
  components: {
    vSelect,
    Datepicker,
    VuePdfEmbed,
  },
  data: function () {
    return {
      baseUrl: "/evaluate",
      mode: "create",
      topic: "",
      content: "",
      evaluate: {
        factory_name: "",
        fid: "",
        dispfacreg: "",
        tax_id: "",
        contact_name: "",
        email: "",
        telephone: "",
        captcha: "",
        policy: "ไม่ยอมรับ",
        category_one_main_one: "ไม่มี",
        category_two_main_one: "ไม่มี",
        category_two_sub_one_one_checkbox: "ไม่มี",
        category_two_sub_one_one_textbox_one: 0,
        category_two_sub_one_one_textbox_two: 0,
        category_two_sub_one_two_checkbox: "ไม่มี",
        category_two_sub_one_two_textbox_one: 0,
        category_two_main_two_checkbox: "ไม่มี",
        category_two_sub_two_checkbox_one: "ไม่มี",
        category_two_sub_two_checkbox_two: "ไม่มี",
        category_two_sub_two_checkbox_three: "ไม่มี",
        category_two_sub_two_checkbox_four: "ไม่มี",
        category_two_sub_two_checkbox_five: "ไม่มี",
        category_two_sub_two_checkbox_six: "ไม่มี",
        category_two_sub_two_checkbox_seven: "ไม่มี",
        category_two_sub_two_checkbox_eight: "ไม่มี",
        category_two_sub_two_checkbox_nine: "ไม่มี",
        category_two_sub_two_checkbox_ten: "ไม่มี",
        category_two_sub_two_checkbox_eleven: "ไม่มี",
        category_two_sub_two_checkbox_twelve: "ไม่มี",
        category_two_sub_two_checkbox_thirteen: "ไม่มี",
        category_two_main_three_checkbox: "ไม่มี",
        category_two_main_three_textbox_one: "",
        category_two_main_four_checkbox: "ไม่มี",
        category_two_main_four_textbox_one: "",
        category_three_main_one: "ไม่มี",
        category_three_sub_one: "ไม่มี",
        category_three_sub_two: "ไม่มี",
        category_three_sub_three: "ไม่มี",
        category_three_sub_four: "ไม่มี",
        category_three_sub_four_textbox_one: 0,
        category_three_sub_five: "ไม่มี",
        category_three_sub_five_textbox_one: 0,
        category_three_sub_six: "ไม่มี",
        category_three_sub_six_textbox_one: 0,
        category_three_sub_seven: "ไม่มี",
        category_three_sub_seven_textbox_one: "",
        category_three_sub_seven_two: 0,
        category_four_main_one: "ไม่มี",
        category_four_sub_one: "ไม่มี",
        category_four_sub_one_textbox_one: 0,
        category_four_sub_two: "ไม่มี",
        category_four_sub_two_textbox_one: 0,
        category_four_sub_three: "ไม่มี",
        category_four_sub_three_textbox_one: 0,
        category_four_sub_four: "ไม่มี",
        category_four_sub_four_textbox_one: 0,
        category_five_main_one: "ไม่มี",
        category_five_sub_one: "ไม่มี",
        category_five_sub_one_textbox_one: 0,
        category_five_sub_two: "ไม่มี",
        category_five_sub_two_textbox_one: "",
        category_five_sub_two_textbox_two: "",
        category_five_sub_two_textbox_three: "",
        category_five_sub_two_textbox_four: 0,
        category_six_main_one: "ไม่มี",
        category_six_sub_one_textbox_one: 0,
        category_seven_main_one: "ไม่มี",
        category_seven_sub_one: "ไม่มี",
        category_seven_sub_one_textbox_one: 0,
        category_seven_sub_two: "ไม่มี",
        category_seven_sub_two_textbox_one: 0,
        category_seven_sub_three: "ไม่มี",
        category_seven_sub_three_textbox_one: 0,
        category_seven_sub_four: "ไม่มี",
        category_seven_sub_four_textbox_one: 0,
        category_seven_sub_five: "ไม่มี",
        category_seven_sub_five_textbox_one: 0,
        category_seven_sub_six: "ไม่มี",
        category_seven_sub_six_textbox_one: 0,
        category_seven_sub_seven_textbox: 0,
        category_eight_main_one: "ไม่มี",
        category_eight_sub_one: "ไม่มี",
        category_eight_sub_two: "ไม่มี",
        category_nine_main_one: "ไม่มี",
        category_nine_sub_two: "ไม่มี",
        category_nine_sub_two_textbox_one: 0,
        category_nine_sub_three: "ไม่มี",
        category_nine_sub_three_textbox_one: 0,
        category_nine_sub_four: "ไม่มี",
        category_nine_sub_four_textbox_one: 0,
        category_nine_sub_five: "ไม่มี",
        category_nine_sub_five_textbox_one: 0,
        category_ten_main_one: "ไม่มี",
        category_eleven_main_one: "ไม่มี",
        category_twelveteen_main_one: "ไม่มี",
        category_twelveteen_sub_one: "ไม่มี",
        category_twelveteen_sub_one_textbox_one: 0,
        category_twelveteen_sub_one_radio_one: "ไม่มี",
        category_twelveteen_sub_two: "ไม่มี",
        category_twelveteen_sub_two_textbox_one: 0,
        category_twelveteen_sub_two_radio_one: "ไม่มี",
        category_thirdteen_main_one: "ไม่มี",
        category_thirdteen_sub_one: "ไม่มี",
        category_thirdteen_sub_one_textbox_one: "",
        category_thirdteen_sub_one_textbox_two: "",
        category_thirdteen_sub_one_textbox_three: "",
        category_thirdteen_sub_one_textbox_four: 0,
        category_thirdteen_sub_one_radio_one: "ไม่มี",
        category_thirdteen_sub_two: "ไม่มี",
        category_thirdteen_sub_two_textbox_one: "",
        category_thirdteen_sub_two_textbox_two: "",
        category_thirdteen_sub_two_textbox_three: "",
        category_thirdteen_sub_two_textbox_four: 0,
        category_thirdteen_sub_two_radio_one: "ไม่มี",
        category_fourteen_main_one: "ไม่มี",
        category_fourteen_sub_one_textbox_one: "",
        category_fourteen_sub_one_textbox_two: "",
        category_fourteen_sub_one_textbox_three: "",
        category_fourteen_sub_one_textbox_four: 0,
        category_fourteen_sub_one_radio_one: "ไม่มี",
        category_fifteen_main_one: "ไม่มี",
        category_sixteen_main_one: "ไม่มี",
        category_sixteen_sub_one_radio_one: "",
        category_sixteen_sub_one_radio_two: "",
        category_seventeen_main_one: "ไม่มี",
        category_seventeen_sub_one: "ไม่มี",
        category_seventeen_sub_one_radio_one: "",
        category_eighteen_main_one: "ไม่มี",
        category_eighteen_sub_one_radio_one: "",
        category_eighteen_sub_one_checkbox_one: "ไม่มี",
        category_eighteen_sub_one_checkbox_two: "ไม่มี",
      },
      itemSecondOneOnes: [],
      itemSecondOneTwos: [],
      page: 1,
      errors: [],
    };
  },
  mounted() {
    this.mode = document.querySelector("#hid-mode")?.value;
    this.evaluate = JSON.parse(document.querySelector("#hid-evaluate")?.value);
    this.addItemSecondOneOne();
    this.addItemSecondOneTwo();
    this.refreshCaptcha();
    if (!this.evaluate) {
      this.evaluate = {
        factory_name: "",
        fid: "",
        dispfacreg: "",
        tax_id: "",
        contact_name: "",
        email: "",
        telephone: "",
        captcha: "",
        policy: "ไม่ยอมรับ",
        category_one_main_one: "ไม่มี",
        category_two_main_one: "ไม่มี",
        category_two_sub_one_one_checkbox: "ไม่มี",
        category_two_sub_one_one_textbox_one: 0,
        category_two_sub_one_one_textbox_two: 0,
        category_two_sub_one_two_checkbox: "ไม่มี",
        category_two_sub_one_two_textbox_one: 0,
        category_two_main_two_checkbox: "ไม่มี",
        category_two_sub_two_checkbox_one: "ไม่มี",
        category_two_sub_two_checkbox_two: "ไม่มี",
        category_two_sub_two_checkbox_three: "ไม่มี",
        category_two_sub_two_checkbox_four: "ไม่มี",
        category_two_sub_two_checkbox_five: "ไม่มี",
        category_two_sub_two_checkbox_six: "ไม่มี",
        category_two_sub_two_checkbox_seven: "ไม่มี",
        category_two_sub_two_checkbox_eight: "ไม่มี",
        category_two_sub_two_checkbox_nine: "ไม่มี",
        category_two_sub_two_checkbox_ten: "ไม่มี",
        category_two_sub_two_checkbox_eleven: "ไม่มี",
        category_two_sub_two_checkbox_twelve: "ไม่มี",
        category_two_sub_two_checkbox_thirteen: "ไม่มี",
        category_two_main_three_checkbox: "ไม่มี",
        category_two_main_three_textbox_one: "",
        category_two_main_four_checkbox: "ไม่มี",
        category_two_main_four_textbox_one: "",
        category_three_main_one: "ไม่มี",
        category_three_sub_one: "ไม่มี",
        category_three_sub_two: "ไม่มี",
        category_three_sub_three: "ไม่มี",
        category_three_sub_four: "ไม่มี",
        category_three_sub_four_textbox_one: 0,
        category_three_sub_five: "ไม่มี",
        category_three_sub_five_textbox_one: 0,
        category_three_sub_six: "ไม่มี",
        category_three_sub_six_textbox_one: 0,
        category_three_sub_seven: "ไม่มี",
        category_three_sub_seven_textbox_one: "",
        category_three_sub_seven_two: 0,
        category_four_main_one: "ไม่มี",
        category_four_sub_one: "ไม่มี",
        category_four_sub_one_textbox_one: 0,
        category_four_sub_two: "ไม่มี",
        category_four_sub_two_textbox_one: 0,
        category_four_sub_three: "ไม่มี",
        category_four_sub_three_textbox_one: 0,
        category_four_sub_four: "ไม่มี",
        category_four_sub_four_textbox_one: 0,
        category_five_main_one: "ไม่มี",
        category_five_sub_one: "ไม่มี",
        category_five_sub_one_textbox_one: 0,
        category_five_sub_two: "ไม่มี",
        category_five_sub_two_textbox_one: "",
        category_five_sub_two_textbox_two: "",
        category_five_sub_two_textbox_three: "",
        category_five_sub_two_textbox_four: 0,
        category_six_main_one: "ไม่มี",
        category_six_sub_one_textbox_one: 0,
        category_seven_main_one: "ไม่มี",
        category_seven_sub_one: "ไม่มี",
        category_seven_sub_one_textbox_one: 0,
        category_seven_sub_two: "ไม่มี",
        category_seven_sub_two_textbox_one: 0,
        category_seven_sub_three: "ไม่มี",
        category_seven_sub_three_textbox_one: 0,
        category_seven_sub_four: "ไม่มี",
        category_seven_sub_four_textbox_one: 0,
        category_seven_sub_five: "ไม่มี",
        category_seven_sub_five_textbox_one: 0,
        category_seven_sub_six: "ไม่มี",
        category_seven_sub_six_textbox_one: 0,
        category_seven_sub_seven_textbox: 0,
        category_eight_main_one: "ไม่มี",
        category_eight_sub_one: "ไม่มี",
        category_eight_sub_two: "ไม่มี",
        category_nine_main_one: "ไม่มี",
        category_nine_sub_two: "ไม่มี",
        category_nine_sub_two_textbox_one: 0,
        category_nine_sub_three: "ไม่มี",
        category_nine_sub_three_textbox_one: 0,
        category_nine_sub_four: "ไม่มี",
        category_nine_sub_four_textbox_one: 0,
        category_nine_sub_five: "ไม่มี",
        category_nine_sub_five_textbox_one: 0,
        category_ten_main_one: "ไม่มี",
        category_eleven_main_one: "ไม่มี",
        category_twelveteen_main_one: "ไม่มี",
        category_twelveteen_sub_one: "ไม่มี",
        category_twelveteen_sub_one_textbox_one: 0,
        category_twelveteen_sub_one_radio_one: "ไม่มี",
        category_twelveteen_sub_two: "ไม่มี",
        category_twelveteen_sub_two_textbox_one: 0,
        category_twelveteen_sub_two_radio_one: "ไม่มี",
        category_thirdteen_main_one: "ไม่มี",
        category_thirdteen_sub_one: "ไม่มี",
        category_thirdteen_sub_one_textbox_one: "",
        category_thirdteen_sub_one_textbox_two: "",
        category_thirdteen_sub_one_textbox_three: "",
        category_thirdteen_sub_one_textbox_four: 0,
        category_thirdteen_sub_one_radio_one: "ไม่มี",
        category_thirdteen_sub_two: "ไม่มี",
        category_thirdteen_sub_two_textbox_one: "",
        category_thirdteen_sub_two_textbox_two: "",
        category_thirdteen_sub_two_textbox_three: "",
        category_thirdteen_sub_two_textbox_four: 0,
        category_thirdteen_sub_two_radio_one: "ไม่มี",
        category_fourteen_main_one: "ไม่มี",
        category_fourteen_sub_one_textbox_one: "",
        category_fourteen_sub_one_textbox_two: "",
        category_fourteen_sub_one_textbox_three: "",
        category_fourteen_sub_one_textbox_four: 0,
        category_fourteen_sub_one_radio_one: "ไม่มี",
        category_fifteen_main_one: "ไม่มี",
        category_sixteen_main_one: "ไม่มี",
        category_sixteen_sub_one_radio_one: "",
        category_sixteen_sub_one_radio_two: "",
        category_seventeen_main_one: "ไม่มี",
        category_seventeen_sub_one: "ไม่มี",
        category_seventeen_sub_one_radio_one: "",
        category_eighteen_main_one: "ไม่มี",
        category_eighteen_sub_one_radio_one: "",
        category_eighteen_sub_one_checkbox_one: "ไม่มี",
        category_eighteen_sub_one_checkbox_two: "ไม่มี",
      };
    }
    // this.fetchFactoryTypes();
    // this.fetchSubClasses();
    // this.fetchAmphurs();
    // this.fetchProvinces();
    // this.fetchTumbols();
  },
  computed: {
    sumCategorySeven() {
      let sum = 0;
      let one = this.evaluate.category_seven_sub_one_textbox_one
        ? parseFloat(this.evaluate.category_seven_sub_one_textbox_one)
        : 0;
      let two = this.evaluate.category_seven_sub_two_textbox_one
        ? parseFloat(this.evaluate.category_seven_sub_two_textbox_one)
        : 0;
      let three = this.evaluate.category_seven_sub_three_textbox_one
        ? parseFloat(this.evaluate.category_seven_sub_three_textbox_one)
        : 0;
      let four = this.evaluate.category_seven_sub_four_textbox_one
        ? parseFloat(this.evaluate.category_seven_sub_four_textbox_one)
        : 0;
      let five = this.evaluate.category_seven_sub_five_textbox_one
        ? parseFloat(this.evaluate.category_seven_sub_five_textbox_one)
        : 0;
      let six = this.evaluate.category_seven_sub_six_textbox_one
        ? parseFloat(this.evaluate.category_seven_sub_six_textbox_one)
        : 0;
      sum = one + two + three + four + five + six;
      this.evaluate.sum_power = sum;
      return this.evaluate.sum_power;
    },
    policyCheck() {
      // if (this.evaluate.policy == 'ไม่ยอมรับ' || this.evaluate.factory_name || this.evaluate.fid || this.evaluate.dispfacreg || this.evaluate.tax_id || this.evaluate.contact_name || this.evaluate.email || this.evaluate.telephone) {
      if (
        this.evaluate.policy == "ไม่ยอมรับ" ||
        (this.evaluate.factory_name == "") | (this.evaluate.fid == "") ||
        this.evaluate.dispfacreg == "" ||
        this.evaluate.tax_id == "" ||
        this.evaluate.contact_name == "" ||
        this.evaluate.email == "" ||
        this.evaluate.telephone == ""
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {},
  methods: {
    itemSecondOneTwoMaxWaste(item) {
      let maxWaste = 0;
      if (this.itemSecondOneTwos.length == 1) {
        console.log(this.itemSecondOneTwos);

        this.itemSecondOneTwos.map((item) => {
          maxWaste = item.category_two_sub_one_one_textbox_two
            ? parseFloat(item.category_two_sub_one_one_textbox_two)
            : 0;
          this.evaluate.max_water_waste_heavy_metal = maxWaste;
        });
        console.log(this.itemSecondOneTwos);
      } else {
        console.log(this.itemSecondOneTwos);

        maxWaste = this.itemSecondOneTwos.reduce((a, b) =>
          Number(a.category_two_sub_one_one_textbox_two) >
            Number(b.category_two_sub_one_one_textbox_two)
            ? a.category_two_sub_one_one_textbox_two
            : b.category_two_sub_one_one_textbox_two
        );
        this.evaluate.max_water_waste_heavy_metal = maxWaste;
        console.log(this.itemSecondOneTwos);
      }
      console.log(this.itemSecondOneTwos);
      return maxWaste;
    },
    itemSecondOneOnesBOD(item) {
      let sum = 0;
      let maxBod = 0;
      let maxWaste = 0;
      let one = item.category_two_sub_one_one_textbox_two
        ? parseFloat(item.category_two_sub_one_one_textbox_two)
        : 0;
      console.log(one);
      let two = item.category_two_sub_one_one_textbox_three
        ? parseFloat(item.category_two_sub_one_one_textbox_three)
        : 0;
      console.log(two);
      sum = (one * two) / 1000;
      item.category_two_sub_one_one_textbox_four = sum;

      if (this.itemSecondOneOnes.length == 1) {
        this.itemSecondOneOnes.map((item) => {
          this.evaluate.max_bod = item.category_two_sub_one_one_textbox_four
            ? parseFloat(item.category_two_sub_one_one_textbox_four)
            : 0;
          this.evaluate.max_water_waste =
            item.category_two_sub_one_one_textbox_two
              ? parseFloat(item.category_two_sub_one_one_textbox_two)
              : 0;
        });
      } else {
        console.log(this.evaluate);

        maxBod = this.itemSecondOneOnes.reduce((a, b) =>
          Number(a.category_two_sub_one_one_textbox_four) >
            Number(b.category_two_sub_one_one_textbox_four)
            ? a.category_two_sub_one_one_textbox_four
            : b.category_two_sub_one_one_textbox_four
        );
        this.evaluate.max_bod = maxBod;
        maxWaste = this.itemSecondOneOnes.reduce((a, b) =>
          Number(a.category_two_sub_one_one_textbox_two) >
            Number(b.category_two_sub_one_one_textbox_two)
            ? a.category_two_sub_one_one_textbox_two
            : b.category_two_sub_one_one_textbox_two
        );
        this.evaluate.max_water_waste = maxWaste;
      }
      console.log(this.evaluate);
      return sum;
    },

    refreshCaptcha() {
      axios.get("/reload-captcha").then((response) => {
        //document.querySelector('.captcha img').src = response.data;
        this.captcha = response.data.captcha;
      });
    },
    next() {
      this.page++;
      window.scrollTo(0, 0);
    },
    back() {
      this.page--;
      window.scrollTo(0, 0);
    },
    close() {
      window.location.href = `/login`;
    },
    addItemSecondOneOne() {
      this.itemSecondOneOnes.push({
        id: uuidv4(),
        category_two_sub_one_one_radio: "",
        category_two_sub_one_one_textbox_one: "",
        category_two_sub_one_one_textbox_two: 0,
        category_two_sub_one_one_textbox_three: 0,
        category_two_sub_one_one_textbox_four: 0,
      });
    },
    removeItemSecondOneOne(fileId) {
      // for (const fileId of this.managerSelected) {
      this.itemSecondOneOnes = this.itemSecondOneOnes.filter(
        (itemSecondOneOne) => itemSecondOneOne.id != fileId
      );
      if (this.itemSecondOneOnes.length == 0) {
        this.evaluate.max_bod = 0;
        this.evaluate.max_water_waste = 0;
      }
      // }
    },
    addItemSecondOneTwo() {
      this.itemSecondOneTwos.push({
        id: uuidv4(),
        category_two_sub_two_one_checkbox_one: "ไม่มี",
        category_two_sub_two_one_checkbox_two: "ไม่มี",
        category_two_sub_two_one_checkbox_three: "ไม่มี",
        category_two_sub_two_one_checkbox_four: "ไม่มี",
        category_two_sub_two_one_checkbox_five: "ไม่มี",
        category_two_sub_two_one_checkbox_six: "ไม่มี",
        category_two_sub_two_one_checkbox_seven: "ไม่มี",
        category_two_sub_two_one_checkbox_eight: "ไม่มี",
        category_two_sub_two_one_checkbox_nine: "ไม่มี",
        category_two_sub_two_one_checkbox_ten: "ไม่มี",
        category_two_sub_two_one_checkbox_eleven: "ไม่มี",
        category_two_sub_two_one_checkbox_twelve: "ไม่มี",
        category_two_sub_two_one_checkbox_thirteen: "ไม่มี",
        category_two_sub_one_one_textbox_one: "",
        category_two_sub_one_one_textbox_two: 0,
      });
    },
    removeItemSecondOneTwo(fileId) {
      // for (const fileId of this.managerSelected) {
      this.itemSecondOneTwos = this.itemSecondOneTwos.filter(
        (itemSecondOneTwo) => itemSecondOneTwo.id != fileId
      );
      if (this.itemSecondOneOnes.length == 0) {
        this.evaluate.max_water_waste_heavy_metal = 0;
      }
      // }
    },
    save() {
      let requestUrl = this.baseUrl;
      let requestMethod = "post";

      Swal.fire({
        icon: "warning",
        title: "ท่านต้องการยืนยันการบันทึกใช่หรือไม่?",
        // text: 'ที่จะทำการจัดส่งเอกสารชุดนี้',
        customClass: "swal-wide",
        showCancelButton: true,
        focusCancel: true,
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .request({
              url: requestUrl,
              method: requestMethod,
              data: {
                evaluate: this.evaluate,
                itemSecondOneOnes: this.itemSecondOneOnes,
                itemSecondOneTwos: this.itemSecondOneTwos,
              },
            })
            .then((response) => {
              Swal.fire("สำเร็จ", response.data.message, "success").then(() => {
                console.log(response.data);
                // window.location.href = `/login`;
                this.page = response.data.page;
                this.topic = response.data.title;
                this.content = response.data.content;
                this.evaluate.factory_name = response.data.factory_name;
              });
            })
            .catch((error) => {
              Swal.fire("ผิดพลาด", error.response.data.message, "error");
              this.errors = error.response.data.errors ?? [];
            });
        }
      });
    },
    // check_validator
    checkValidator(target_validator, type) {
      let validator = $('.' + target_validator).jbvalidator({
        errorMessage: true,
        successClass: true,
        language: "/vendor/jquery-form-validation/jquery3-bootstrap5/src/lang/th.json",
        html5BrowserDefault: false,
        validFeedBackClass: 'valid-feedback',
        invalidFeedBackClass: 'invalid-feedback',
        validClass: 'is-valid',
        invalidClass: 'is-invalid'
      });
      //check form without submit
      //validator.checkAll(); //return error count

      //reload instance after dynamic element is added
      validator.reload();

      if (type == 'check_onchange') {
        //reload instance after dynamic element is added
        validator.reload();
      }

      if (type == 'check_onsubmit_step_1_next') {
        //check form without submit
        var error_count = validator.checkAll(); //return error count
        if (error_count != 0) {
          $('html, body').animate({
            scrollTop: ($('.invalid-feedback').offset().top - 300)
          }, 0);
          return false;
        }
        this.next();
      }

      if (type == 'check_onsubmit_step_2_next') {
        //check form without submit
        var error_count = validator.checkAll(); //return error count
        if (error_count != 0) {
          $('html, body').animate({
            scrollTop: ($('.invalid-feedback').offset().top - 300)
          }, 0);
          return false;
        }
        this.next();
      }

      $(".invalid-feedback").css({
        "font-size": "0.825rem",
        "margin-top": "0.005rem"
      });
    }
  },
};
</script>
